import React, { useState, useEffect } from 'react';
// import Typography from '@mui/material/Typography';
import {
  Box,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography,
  FormGroup,
  Checkbox,
  MobileStepper,
  Button,
  TextField,
  TextareaAutosize,
  MenuItem,
  Stack,
  Grid
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import AppBarWithMenu from '../../components/appbarwithmenu';
import Footer from '../../components/footer';
import appTheme from '../../components/apptheme';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Tooltip from '@mui/material/Tooltip';
import BadgeIcon from '@mui/icons-material/Badge';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Pageview from '@mui/icons-material/Pageview';
import DriveFolderUploadRounded from '@mui/icons-material/DriveFolderUploadRounded';
import * as CaseType from '../../config/caseType';
import { GENDER } from '../../config/gender';
import AddIcon from '@mui/icons-material/Add';
// import MultipleSelectChip from '../../components/mutiselect1';
import { LANGUAGES, getNames } from '../../config/language';
import { PROGRAM, SURGEON, WHYCHOOSE, PHONES } from '../../config/picklist';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@mui/material';
import { US_STATES_SORT_BY_NAME } from '../../config/USStates';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
// page 1
import * as setcasetypeAction from '../../actions/setcasetypeAction';
import * as patientActions from '../../actions/patientActions';
// page 2
import { useFormik } from 'formik';
import {
  validateAboutYouForm,
  validateStoryForm,
  validateAddressForm,
  validateEmailPhoneForm,
  validateLanguageForm,
  validateCardiologistForm,
  validatePCPForm,
  validateOBGYNForm,
  validateBCHMDInfoForm,
  validateOtherInfoForm
} from './ValidateCaseForms';
import { countries } from '../../config/country';
import * as caseActions from '../../actions/caseActions';
import { getCountryCode } from '../../config/country';
import { getUSStateAbbr } from '../../config/USStates';
import {
  getSurgeonName,
  getWhyChooseText,
  getProgramText,
  getSurgeonValue,
  getWhyChooseValue,
  getProgramValue,
  getPhoneTypeValue,
  getPhoneTypeText
} from '../../config/picklist';
// import getLocalCountryName from '../../api/methods/localizedInfo';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as logoutAction from '../../actions/logoutAction';
import { ReactComponent as BCHLogoSOP } from '../../images/BCH-logo-SOP.svg';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
//import * as loginActions from '../../actions/loginActions';
import ContactMessage from '../message/contactmessage';
import CaseExistMessage from '../message/caseexistmessage';
import RequestAccessMessage from '../message/requestaccessmessage';
import { useSnackbar } from 'notistack';
import * as Constants from '../../config/constants';
import * as loginActions from '../../actions/loginActions';
import InfoIcon from '@mui/icons-material/Info';
//import { FileUploader } from 'react-drag-drop-files';
import { DropzoneArea } from 'mui-file-dropzone';
import { ReactComponent as HeartLogo } from '../../images/Logo-Rebekah.svg';

// import dayjs from 'dayjs';
// import ToHome from '../../components/tohome';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const infoIcon = <InfoIcon sx={{ fontSize: 20 }} color="info" />;
//const fileTypes = ['BMP', 'JPEG', 'JPG', 'PNG', 'GIF', 'TIF', 'TIFF'];

export default function Case() {
  // const [value, setValue] = React.useState('');
  console.log('Case: - Case page loading...');
  const theme = useTheme();
  let navigate = useNavigate();
  // redux
  const dispatch = useDispatch();
  const st = useSelector((state) => state.rootReducer);
  // const [activeStep, setActiveStep] = React.useState(0);
  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const [showDialogFromMenu, setShowDialogFromMenu] = useState(false);

  const [createCaseSubmitted, setCreateCaseSubmitted] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showCaseAlreadyLinked, setShowCaseAlreadyLinked] = useState(false);
  const [showCaseAccessRequested, setShowCaseAccessRequested] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // const [saveBasicInfoSubmitted, setSaveBasicInfoSubmitted] = useState(false);
  const [saveContactInfoSubmitted, setSaveContactInfoSubmitted] = useState(false);
  const [saveMDInfoSubmitted, setSaveMDInfoSubmitted] = useState(false);
  const [saveBCHInfoSubmitted, setSaveBCHInfoSubmitted] = useState(false);
  const [showContactMessage, setShowContactMessage] = useState(false);
  const [selection, setSelection] = useState('0');
  const detectMobileType = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'iPhone'
      : /Android/i.test(navigator.userAgent)
      ? 'Android'
      : 'Desktop';

  const onMobile = detectMobileType() !== 'Desktop';
  React.useEffect(() => {
    if (
      createCaseSubmitted &&
      !st.isCreateCaseLoading &&
      !st.isGetCaseLoading &&
      st.createcaseerror === ''
    ) {
      console.log('Navigate to message page');
      setLoading(false);
      if (st.returnCode === 206) setShowCaseAlreadyLinked(true);
      else if (st.returnCode === 202) setShowCaseAccessRequested(true);
      else if (st.returnCode === 201 && st.activeStep === 1) {
        setCreateCaseSubmitted(false);
        handleNext();
      } else if (st.returnCode === 201 && st.activeStep === 3) {
        enqueueSnackbar(Constants.CREATE_CASE_SUCCESS, {
          variant: 'success'
        });
        setCreateCaseSubmitted(false);
        handleNext();
      }
    } else if (
      createCaseSubmitted &&
      !st.isCreateCaseLoading &&
      !st.isGetCaseLoading &&
      st.createcaseerror !== ''
    ) {
      setLoading(false);
    } /*else if (saveBasicInfoSubmitted && !st.isUpdateCaseLoading && st.updatebasicerror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveBasicInfoSubmitted(false);
      handleNext();
    } */ else if (
      saveContactInfoSubmitted &&
      !st.isUpdateCaseLoading &&
      st.updatecontacterror === ''
    ) {
      /*enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });*/
      setSaveContactInfoSubmitted(false);
      handleNext();
    } else if (saveMDInfoSubmitted && !st.isUpdateCaseLoading && st.updatemderror === '') {
      /*enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });*/
      setSaveMDInfoSubmitted(false);
      handleNext();
    } else if (saveBCHInfoSubmitted && !st.isUpdateCaseLoading && st.updatebcherror === '') {
      /*enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });*/
      setSaveBCHInfoSubmitted(false);
      handleNext();
    }
  }, [
    createCaseSubmitted,
    st.isCreateCaseLoading,
    st.isGetCaseLoading,
    st.createcaseerror,
    st.caseId,
    st.isUpdateCaseLoading,
    // saveBasicInfoSubmitted,
    saveContactInfoSubmitted,
    saveMDInfoSubmitted,
    saveBCHInfoSubmitted,
    st.updatebasicerror,
    st.updatecontacterror,
    st.updatemderror,
    st.updatebcherror
  ]);

  // step 1
  var caseType = st.caseType;

  const [option, setOption] = useState(
    caseType === 'your child' || caseType === 'yourself' || caseType === 'your fetus'
      ? caseType
      : caseType === 'other relative' || caseType === 'other not relative'
      ? 'other relative'
      : 'your fetus'
  );
  const [mother, setMother] = useState(caseType === 'your fetus' ? true : false);
  const [relative, setRelative] = useState(true);
  const [showMother, setShowMother] = useState(
    caseType === 'your fetus' || caseType === 'fetus not mother' ? true : false
  );
  const [showRelative, setShowRelative] = useState(
    caseType === 'other relative' || caseType === 'other not relative'
  );

  // const [value, setValue] = React.useState(dayjs());
  // const [value, setValue] = React.useState(new Date());
  // step 4
  const [showAddress2, setShowAddress2] = useState(
    st.patient.secondaryAddressline1 !== '' ||
      st.patient.secondaryAddressline2 !== '' ||
      st.patient.secondaryCity !== '' ||
      st.patient.secondaryState !== '' ||
      st.patient.secondaryCountry !== '' ||
      st.patient.secondaryZip !== ''
      ? true
      : false
  );
  // const [defaultCountry, setDefaultCountry] = useState('');

  // step 5
  const [showEmail2, setShowEmail2] = useState(st.patient.email2 !== '' ? true : false);
  const [showPhone2, setShowPhone2] = useState(st.patient.phone2 !== '' ? true : false);
  const [showPhone3, setShowPhone3] = useState(st.patient.phone3 !== '' ? true : false);
  const [showPhone4, setShowPhone4] = useState(st.patient.phone4 !== '' ? true : false);
  const [countryCodePhone1, setCountryCodePhone1] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.phone !== undefined &&
      st.patient.phone !== ''
      ? st.patient.phone.split(' ')[0] !== null
        ? st.patient.phone.slice(0, st.patient.phone.indexOf(' '))
        : '+1'
      : '+1'
  );
  const [countryCodePhone2, setCountryCodePhone2] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.phone2 !== undefined &&
      st.patient.phone2 !== ''
      ? st.patient.phone2.split(' ')[0] !== null
        ? st.patient.phone2.slice(0, st.patient.phone2.indexOf(' '))
        : '+1'
      : '+1'
  );

  const [countryCodePhone3, setCountryCodePhone3] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.phone3 !== undefined &&
      st.patient.phone3 !== ''
      ? st.patient.phone3.split(' ')[0] !== null
        ? st.patient.phone3.slice(0, st.patient.phone3.indexOf(' '))
        : '+1'
      : '+1'
  );

  const [countryCodePhone4, setCountryCodePhone4] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.phone4 !== undefined &&
      st.patient.phone4 !== ''
      ? st.patient.phone4.split(' ')[0] !== null
        ? st.patient.phone4.slice(0, st.patient.phone4.indexOf(' '))
        : '+1'
      : '+1'
  );
  // step 7
  const [countryCode1, setCountryCode1] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.cardiologistphone !== undefined &&
      st.patient.cardiologistphone !== ''
      ? st.patient.cardiologistphone.split(' ')[0] !== null
        ? st.patient.cardiologistphone.slice(0, st.patient.cardiologistphone.indexOf(' '))
        : '+1'
      : '+1'
  );

  // step 8
  const [countryCode2, setCountryCode2] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.pcpphone !== undefined &&
      st.patient.pcpphone !== ''
      ? st.patient.pcpphone.split(' ')[0] !== null
        ? st.patient.pcpphone.slice(0, st.patient.pcpphone.indexOf(' '))
        : '+1'
      : '+1'
  );
  // step 9
  const [countryCode3, setCountryCode3] = useState(
    st !== undefined &&
      st.patient !== undefined &&
      st.patient.obgynphone !== undefined &&
      st.patient.obgynphone !== ''
      ? st.patient.obgynphone.split(' ')[0] !== null
        ? st.patient.obgynphone.slice(0, st.patient.obgynphone.indexOf(' '))
        : '+1'
      : '+1'
  );

  useEffect(() => {
    if (st.localCountryName === '') {
      axios
        .get('https://ipapi.co/json/')
        .then((response) => {
          let data = response.data;
          console.log('get default country name from IPAPI: ', data.country_name);
          // update country default value if currently is empty
          dispatch(caseActions.setLocalCountryName(data.country_name));
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (st.patient.country === '' && st.localCountryName !== '') {
      dispatch(patientActions.updatePatientCountry(st.localCountryName));
      dispatch(patientActions.updatePatientSecondaryCountry(st.localCountryName));
    }
  }, [st.localCountryName, st.patient.country, dispatch]);

  const handleCancelToHome = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    // if (!fromMenu) {
    dispatch(caseActions.setViewSummary(true));
    // }
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
  };
  // step 0
  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
  };
  const handleSelectionContinue = () => {
    if (selection === '0') {
      dispatch(caseActions.setShowWelcome(false));
    }
    if (selection === '1') {
      navigate('/sop2web/requestview');
    }
  };
  // step 1
  const handleCaseTypeChange = (event) => {
    // setCaseType(event.target.value);
    setOption(event.target.value);
    if (event.target.value === 'your fetus') {
      setShowMother(true);
    } else {
      setShowMother(false);
    }
    if (event.target.value === 'other relative') {
      setShowRelative(true);
    } else {
      setShowRelative(false);
    }
  };

  const handleMotherCheckboxChange = (event) => {
    setMother(event.target.checked);
  };

  const handleRelativeCheckboxChange = (event) => {
    setRelative(event.target.checked);
  };
  function getCaseType() {
    let casetype = option;
    if (option === 'your fetus' && mother === true) {
      casetype = 'your fetus';
    } else if (option === 'your fetus' && mother === false) {
      casetype = 'fetus not mother';
    } else if (option === 'other relative' && relative === true) {
      casetype = 'other relative';
    } else if (option === 'other relative' && relative === false) {
      casetype = 'other not relative';
    }
    return casetype;
  }

  const handleCaseTypeNext = () => {
    let casetype = getCaseType();
    console.log(casetype);
    dispatch(setcasetypeAction.setCaseType(casetype));
    if (casetype === 'yourself' || casetype === 'your fetus') {
      if (st.patient.firstName === undefined || st.patient.firstName === '') {
        dispatch(patientActions.updatePatientFirstname(st.firstName));
      }
      if (st.patient.lastName === undefined || st.patient.firstName === '') {
        dispatch(patientActions.updatePatientLastname(st.lastName));
      }
    }

    if (casetype === 'your fetus' || casetype === 'fetus not mother') {
      dispatch(patientActions.updatePatientGender('female'));
    }

    if (casetype !== 'your fetus' || casetype !== 'fetus not mother') {
      dispatch(patientActions.updatePatientDueDate(''));
    }

    if (showRelative === true && !relative) {
      // add contact info message
      console.log('Navigate to message screen');
      setShowContactMessage(true);
    } else dispatch(caseActions.setActiveStep(st.activeStep + 1));
  };

  const handleCaseTypeBack = () => {
    dispatch(caseActions.setActiveStep(st.activeStep - 1));
    navigate('/sop2web/home');
  };

  // step 2
  const dateToString = (dt) => {
    // Parse date without timezone
    if (dt === null) {
      dt = new Date();
    }
    try {
      var date_to_convert = new Date(
        dt.getUTCFullYear(),
        dt.getUTCMonth(),
        dt.getUTCDate(),
        10,
        0,
        0,
        0
      );
      return date_to_convert.toDateString().slice(4);
    } catch (error) {
      console.log(error);
      return new Date().toDateString().slice(4);
    }
  };
  const handleAboutYouNext = (values) => {
    console.log(values);
    // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
    dispatch(
      patientActions.persistPatientInfo(
        values.firstName,
        values.lastName,
        values.dob,
        values.gender,
        values.dueDate,
        st.patient.story
      )
    );
    dispatch(caseActions.setActiveStep(st.activeStep + 1));
    /*var createCaseRequest = {
      caseId: 0,
      caseType: getCaseType(),
      patientFirstName: values.firstName,
      patientLastName: values.lastName,
      patientDob: values.dob,
      gender: values.gender,
      dueDay: '',
      story: '',
      email: st.userDetail.email,
      methodOfCaseCreation: '',
      email1: '',
      email2: '',
      phone1: '',
      phone2: '',
      phone3: '',
      phone4: '',
      phone1Type: '',
      phone2Type: '',
      phone3Type: '',
      phone4Type: ''
    };
    dispatch(caseActions.requestCreateCase(createCaseRequest));*/
  };

  const formikAboutYou = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName:
        st !== undefined && st.patient.firstName !== ''
          ? st.patient.firstName
          : (option === 'yourself' || (option === 'your fetus' && mother === true)) &&
            st.userDetail !== null &&
            st.userDetail.given_name !== null
          ? st.userDetail.given_name
          : '',
      lastName:
        st !== undefined && st.patient.lastName !== ''
          ? st.patient.lastName
          : (option === 'yourself' || (option === 'your fetus' && mother === true)) &&
            st.userDetail !== null &&
            st.userDetail.family_name !== null
          ? st.userDetail.family_name
          : '',
      dob:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.dob !== null &&
        st.patient.dob !== '' &&
        st.patient.dob !== undefined
          ? dateToString(new Date(st.patient.dob))
          : '',
      gender: st !== undefined ? st.patient.gender : '',
      dueDate:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.dueDate !== null &&
        st.patient.dueDate !== '' &&
        st.patient.dueDate !== undefined
          ? dateToString(new Date(st.patient.dueDate))
          : ''
    },
    validationSchema: validateAboutYouForm,
    onSubmit: (values) => {
      // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
      //submitCreateCase(values);
      //setLoading(true);
      handleAboutYouNext(values);

      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setCreateCaseSubmitted(false);
      // reset fromMenu
      // setFromMenu(false);
      // handleNext();
    }
  });

  // step 3
  const handleCaseStoryNext = (values) => {
    console.log(values);
    
    // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
    //filter out white spaces 
    dispatch(
      patientActions.persistPatientInfo(
        st.patient.firstName,
        st.patient.lastName,
        st.patient.dob,
        st.patient.gender,
        st.patient.dueDate,
        values.story.trim()
      )
    );
    // setSaveBasicInfoSubmitted(true);
    dispatch(caseActions.setActiveStep(st.activeStep + 1));
  };
  /*
  const updateCaseStory = (values) => {
    console.log(values);
    // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
    dispatch(
      patientActions.persistPatientInfo(
        st.patient.firstName,
        st.patient.lastName,
        st.patient.dob,
        st.patient.gender,
        st.patient.dueDate,
        values.story
      )
    );
    var editCaseRequest = {
      caseId: st.caseId,
      caseType: st.caseType,
      patientFirstName: st.patient.firstName,
      patientLastName: st.patient.lastName,
      patientDob: st.patient.dob,
      gender: st.patient.gender,
      dueDay: option === 'your fetus' ? st.patient.dueDate : '',
      story: values.story
    };
    dispatch(caseActions.requestUpdateCaseBasicInfo(editCaseRequest));
    // setSaveBasicInfoSubmitted(true);
  };*/
  const formikStory = useFormik({
    enableReinitialize: true,
    initialValues: {
      story: st !== undefined ? st.patient.story : ''
    },
    validationSchema: validateStoryForm,
    onSubmit: (values) => {
      console.log(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      // reset fromMenu
      // setFromMenu(false);
      // alert('Submit UpdateStory API\n' + JSON.stringify(values, null, 2));
      // updateCaseStory(values);
      // submitCreateCase(values);
      // setLoading(true);
      // setCreateCaseSubmitted(true);
      handleCaseStoryNext(values);
    }
  });

  // step 4
  const submitCreateCase = (values) => {
    console.log(values);
    dispatch(
      patientActions.persistPatientContactInfo(
        st.patient.addressline1,
        st.patient.addressline2,
        st.patient.city,
        st.patient.state,
        st.patient.country,
        st.patient.zip,
        st.patient.secondaryAddressline1,
        st.patient.secondaryAddressline2,
        st.patient.secondaryCity,
        st.patient.secondaryState,
        st.patient.secondaryCountry,
        st.patient.secondaryZip,
        values.email,
        values.email2,
        values.phone,
        values.phone2,
        values.phone3,
        values.phone4,
        values.phonetype,
        values.phonetype2,
        values.phonetype3,
        values.phonetype4,
        st.patient.languages,
        st.patient.needInterpreter
      )
    );
    // set browser name
    var browserName = (function (agent) {
      switch (true) {
        case agent.indexOf('edge') > -1:
          return 'MS Edge';
        case agent.indexOf('edg/') > -1:
          return 'Edge (chromium based)';
        case agent.indexOf('opr') > -1 && !!window.opr:
          return 'Opera';
        case agent.indexOf('chrome') > -1 && !!window.chrome:
          return 'Chrome';
        case agent.indexOf('trident') > -1:
          return 'MS IE';
        case agent.indexOf('firefox') > -1:
          return 'Mozilla Firefox';
        case agent.indexOf('safari') > -1:
          return 'Safari';
        default:
          return 'other';
      }
    })(window.navigator.userAgent.toLowerCase());

    const detectMobileType = () =>
      /iPhone/i.test(navigator.userAgent)
        ? 'iPhone'
        : /Android/i.test(navigator.userAgent)
        ? 'Android'
        : /iPad/i.test(navigator.userAgent)
        ? 'iPad'
        : /iPod/i.test(navigator.userAgent)
        ? 'iPod'
        : 'Desktop';
    console.log(detectMobileType());

    var createCaseRequest = {
      caseId: 0,
      caseType: getCaseType(),
      patientFirstName: st.patient.firstName,
      patientLastName: st.patient.lastName,
      patientDob: st.patient.dob,
      gender: st.patient.gender,
      dueDay: option === 'your fetus' ? st.patient.dueDate : '',
      story: st.patient.story,
      email: st.email,
      methodOfCaseCreation: 'Via web(' + browserName + ') on ' + detectMobileType(),
      email1: values.email,
      email2: values.email2,
      phone1: formatPhoneToSave(countryCodePhone1, values.phone),
      phone2: formatPhoneToSave(countryCodePhone2, values.phone2),
      phone3: formatPhoneToSave(countryCodePhone3, values.phone3),
      phone4: formatPhoneToSave(countryCodePhone4, values.phone4),
      phone1Type: getPhoneTypeValue(values.phonetype),
      phone2Type: getPhoneTypeValue(values.phonetype2),
      phone3Type: getPhoneTypeValue(values.phonetype3),
      phone4Type: getPhoneTypeValue(values.phonetype4)
    };
    dispatch(caseActions.requestCreateCase(createCaseRequest));
  };
  /*
  const updateCaseEmailPhone = (values) => {
    dispatch(
      patientActions.persistPatientContactInfo(
        st.patient.addressline1,
        st.patient.addressline2,
        st.patient.city,
        st.patient.state,
        st.patient.country,
        st.patient.zip,
        st.patient.secondaryAddressline1,
        st.patient.secondaryAddressline2,
        st.patient.secondaryCity,
        st.patient.secondaryState,
        st.patient.secondaryCountry,
        st.patient.secondaryZip,
        values.email,
        values.email2,
        values.phone,
        values.phone2,
        values.phone3,
        values.phone4,
        values.phonetype,
        values.phonetype2,
        values.phonetype3,
        values.phonetype4,
        st.patient.languages,
        st.patient.needInterpreter
      )
    );

    var editCaseContactInfoRequest = {
      caseId: st.caseId,
      addressLine1: st.patient.addressline1,
      addressLine2: st.patient.addressline2,
      city: st.patient.city,
      stateProvince:
        st.patient.country !== 'United States'
          ? st.patient.state
          : getUSStateAbbr(st.patient.state),
      country: getCountryCode(st.patient.country),
      zip: st.patient.zip,
      secondaryAddressLine1: st.patient.secondaryAddressline1,
      secondaryAddressLine2: st.patient.secondaryAddressline2,
      secondaryCity: st.patient.secondaryCity,
      secondaryStateProvince:
        st.patient.secondaryCountry !== 'United States'
          ? st.patient.secondaryState
          : getUSStateAbbr(st.patient.secondaryState),
      secondaryCountry: getCountryCode(st.patient.secondaryCountry),
      secondaryZip: st.patient.secondaryZip,
      email1: values.email,
      email2: values.email2,
      phone1: formatPhoneToSave(countryCodePhone1, values.phone),
      phone2: formatPhoneToSave(countryCodePhone2, values.phone2),
      phone3: formatPhoneToSave(countryCodePhone3, values.phone3),
      phone4: formatPhoneToSave(countryCodePhone4, values.phone4),
      phone1Type: getPhoneTypeValue(values.phonetype),
      phone2Type: getPhoneTypeValue(values.phonetype2),
      phone3Type: getPhoneTypeValue(values.phonetype3),
      phone4Type: getPhoneTypeValue(values.phonetype4),
      languages: getNames(st.patient.languages),
      needInterpreter: st.patient.needInterpreter,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseContactInfo(editCaseContactInfoRequest));
  };*/
  const formikEmailPhone = useFormik({
    enableReinitialize: true,
    initialValues: {
      email:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.email !== undefined &&
        st.patient.email !== ''
          ? st.patient.email
          : st !== undefined
          ? st.email
          : '',
      email2:
        st !== undefined &&
        st.patient !== undefined &&
        st.patient.email2 !== undefined &&
        st.patient.email2 !== ''
          ? st.patient.email2
          : '',
      phone:
        st !== undefined && st.patient.phone !== undefined && st.patient.phone !== ''
          ? st.patient.phone
          : st.userDetail !== null &&
            st.userDetail !== undefined &&
            st.userDetail.phone_number !== undefined &&
            st.userDetail.phone_number !== null
          ? st.userDetail.phone_number
          : '',
      phone2:
        st !== undefined && st.patient.phone2 !== undefined && st.patient.phone2 !== ''
          ? st.patient.phone2
          : '',
      phone3:
        st !== undefined && st.patient.phone3 !== undefined && st.patient.phone3 !== ''
          ? st.patient.phone3
          : '',
      phone4:
        st !== undefined && st.patient.phone4 !== undefined && st.patient.phone4 !== ''
          ? st.patient.phone4
          : '',
      phonetype:
        st !== undefined && st.patient.phonetype !== undefined
          ? getPhoneTypeText(st.patient.phonetype)
          : '',
      phonetype2:
        st !== undefined && st.patient.phonetype2 !== undefined
          ? getPhoneTypeText(st.patient.phonetype2)
          : '',
      phonetype3:
        st !== undefined && st.patient.phonetype3 !== undefined
          ? getPhoneTypeText(st.patient.phonetype3)
          : '',
      phonetype4:
        st !== undefined && st.patient.phonetype4 !== undefined
          ? getPhoneTypeText(st.patient.phonetype4)
          : ''
    },
    validationSchema: validateEmailPhoneForm,
    onSubmit: (values) => {
      // alert('Submit UpdateEmailPhone API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      // reset fromMenu
      // setFromMenu(false);
      // updateCaseEmailPhone(values);
      submitCreateCase(values);
      setLoading(true);
      setCreateCaseSubmitted(true);
      // setSaveContactInfoSubmitted(true);
      //handleNext();
    }
  });
  const addEmail = () => {
    setShowEmail2(true);
  };
  const addPhone = () => {
    if (!showPhone2) {
      setShowPhone2(true);
    } else if (!showPhone3) {
      setShowPhone3(true);
    } else if (!showPhone4) {
      setShowPhone4(true);
    }
  };
  // step 5
  const updateCaseAddress = (values) => {
    dispatch(
      patientActions.persistPatientContactInfo(
        values.addressline1,
        values.addressline2,
        values.city,
        values.country == 'United States' ? values.state : values.province,
        values.country,
        values.zip,
        values.secondaryAddressline1,
        values.secondaryAddressline2,
        values.secondaryCity,
        values.secondaryCountry == 'United States'
          ? values.secondaryState
          : values.secondaryProvince,
        values.secondaryCountry,
        values.secondaryZip,
        st.patient.email,
        st.patient.email2,
        st.patient.phone,
        st.patient.phone2,
        st.patient.phone3,
        st.patient.phone4,
        st.patient.phonetype,
        st.patient.phonetype2,
        st.patient.phonetype3,
        st.patient.phonetype4,
        st.patient.languages,
        st.patient.needInterpreter
      )
    );

    var editCaseContactInfoRequest = {
      caseId: st.caseId,
      addressLine1: values.addressline1,
      addressLine2: values.addressline2,
      city: values.city,
      stateProvince:
        values.country !== 'United States' ? values.province : getUSStateAbbr(values.state),
      country: getCountryCode(values.country),
      zip: values.zip,
      secondaryAddressLine1: values.secondaryAddressline1,
      secondaryAddressLine2: values.secondaryAddressline2,
      secondaryCity: values.secondaryCity,
      secondaryStateProvince:
        values.secondaryCountry !== 'United States'
          ? values.secondaryProvince
          : getUSStateAbbr(values.secondaryState),
      secondaryCountry: getCountryCode(values.secondaryCountry),
      secondaryZip: values.secondaryZip,
      email1: st.patient.email,
      email2: st.patient.email2,
      phone1: formatPhoneToSave(countryCodePhone1, st.patient.phone),
      phone2: formatPhoneToSave(countryCodePhone2, st.patient.phone2),
      phone3: formatPhoneToSave(countryCodePhone3, st.patient.phone3),
      phone4: formatPhoneToSave(countryCodePhone4, st.patient.phone4),
      phone1Type: getPhoneTypeValue(st.patient.phonetype),
      phone2Type: getPhoneTypeValue(st.patient.phonetype2),
      phone3Type: getPhoneTypeValue(st.patient.phonetype3),
      phone4Type: getPhoneTypeValue(st.patient.phonetype4),
      languages: getNames(st.patient.languages),
      needInterpreter: st.patient.needInterpreter,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseContactInfo(editCaseContactInfoRequest));
  };
  const formikAddress = useFormik({
    enableReinitialize: true,
    initialValues: {
      addressline1: st !== undefined ? st.patient.addressline1 : '',
      addressline2: st !== undefined ? st.patient.addressline2 : '',
      city: st !== undefined ? st.patient.city : '',
      state: st !== undefined && st.patient.state !== undefined ? st.patient.state : '',
      province: st !== undefined && st.patient.state !== undefined ? st.patient.state : '',
      country:
        st !== undefined && st.patient.country !== undefined && st.patient.country !== ''
          ? st.patient.country
          : st.localCountryName,
      zip: st !== undefined ? st.patient.zip : '',
      secondaryAddressline1: st !== undefined ? st.patient.secondaryAddressline1 : '',
      secondaryAddressline2: st !== undefined ? st.patient.secondaryAddressline2 : '',
      secondaryCity: st !== undefined ? st.patient.secondaryCity : '',
      secondaryState:
        st !== undefined && st.patient.secondaryState !== undefined
          ? st.patient.secondaryState
          : '',
      secondaryProvince:
        st !== undefined && st.patient.secondaryState !== undefined
          ? st.patient.secondaryState
          : '',
      secondaryCountry:
        st !== undefined &&
        st.patient.secondaryCountry !== undefined &&
        st.patient.secondaryCountry !== ''
          ? st.patient.secondaryCountry
          : st.localCountryName,
      secondaryZip: st !== undefined ? st.patient.secondaryZip : ''
    },
    validationSchema: validateAddressForm,
    onSubmit: (values) => {
      // alert('Submit UpdateAddress API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      // reset fromMenu
      // setFromMenu(false);
      updateCaseAddress(values);
      setSaveContactInfoSubmitted(true);
      //handleNext();
    }
  });
  const addAddress = () => {
    setShowAddress2(true);
  };

  // step 6
  const updateCaseLanguage = (values) => {
    dispatch(
      patientActions.persistPatientContactInfo(
        st.patient.addressline1,
        st.patient.addressline2,
        st.patient.city,
        st.patient.state,
        st.patient.country,
        st.patient.zip,
        st.patient.secondaryAddressline1,
        st.patient.secondaryAddressline2,
        st.patient.secondaryCity,
        st.patient.secondaryState,
        st.patient.secondaryCountry,
        st.patient.secondaryZip,
        st.patient.email,
        st.patient.email2,
        st.patient.phone,
        st.patient.phone2,
        st.patient.phone3,
        st.patient.phone4,
        st.patient.phonetype,
        st.patient.phonetype2,
        st.patient.phonetype3,
        st.patient.phonetype4,
        values.languages,
        values.needInterpreter
      )
    );

    var editCaseContactInfoRequest = {
      caseId: st.caseId,
      addressLine1: st.patient.addressline1,
      addressLine2: st.patient.addressline2,
      city: st.patient.city,
      stateProvince:
        st.patient.country !== 'United States'
          ? st.patient.state
          : getUSStateAbbr(st.patient.state),
      country: getCountryCode(st.patient.country),
      zip: st.patient.zip,
      secondaryAddressLine1: st.patient.secondaryAddressline1,
      secondaryAddressLine2: st.patient.secondaryAddressline2,
      secondaryCity: st.patient.secondaryCity,
      secondaryStateProvince:
        st.patient.secondaryCountry !== 'United States'
          ? st.patient.secondaryState
          : getUSStateAbbr(st.patient.secondaryState),
      secondaryCountry: getCountryCode(st.patient.secondaryCountry),
      secondaryZip: st.patient.secondaryZip,
      email1: st.patient.email,
      email2: st.patient.email2,
      phone1: formatPhoneToSave(countryCodePhone1, st.patient.phone),
      phone2: formatPhoneToSave(countryCodePhone2, st.patient.phone2),
      phone3: formatPhoneToSave(countryCodePhone3, st.patient.phone3),
      phone4: formatPhoneToSave(countryCodePhone4, st.patient.phone4),
      phone1Type: getPhoneTypeValue(st.patient.phonetype),
      phone2Type: getPhoneTypeValue(st.patient.phonetype2),
      phone3Type: getPhoneTypeValue(st.patient.phonetype3),
      phone4Type: getPhoneTypeValue(st.patient.phonetype4),
      languages: getNames(values.languages),
      needInterpreter: values.needInterpreter,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseContactInfo(editCaseContactInfoRequest));
  };
  const formikLanguage = useFormik({
    enableReinitialize: true,
    initialValues: {
      languages: st !== undefined ? st.patient.languages : [29],
      needInterpreter:
        st !== undefined && st.patient.needInterpreter !== undefined
          ? st.patient.needInterpreter
          : 'N'
    },
    validationSchema: validateLanguageForm,
    onSubmit: (values) => {
      // alert('Submit UpdateLanguage API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCaseLanguage(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveContactInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      //handleNext();
    }
  });

  // step 7
  function formatPhoneToSave(countryCode, phone) {
    if (phone == undefined) return countryCode;
    else
      return (
        phone.substring(0, countryCode.length) +
        ' ' +
        phone.substring(countryCode.length, phone.length)
      );
  }
  const updateCaseCardiologist = (values) => {
    dispatch(
      patientActions.persistPatientMDInfo(
        st.patient.pcp,
        st.patient.pcpphone,
        st.patient.pcpemail !== undefined ? st.patient.pcpemail.trim() : st.patient.pcpemail,
        values.cardiologist,
        values.cardiologistphone,
        values.cardiologistemail !== undefined
          ? values.cardiologistemail.trim()
          : values.cardiologistemail,
        st.patient.obgyn,
        st.patient.obgynphone,
        st.patient.obgynemail !== undefined ? st.patient.obgynemail.trim() : st.patient.obgynemail,
        st.patient.pcpletter,
        values.cardiologistletter,
        st.patient.obgynletter
      )
    );
    var letter1 = st.patient.pcpletter === 'true' ? 'Primary Care Physician' : '';
    var letter2 =
      st.patient.pcpletter === 'true' && values.cardiologistletter === 'true'
        ? ',Cardiologist'
        : values.cardiologistletter === 'true'
        ? 'Cardiologist'
        : '';
    var letter3 =
      st.patient.pcpletter !== 'true' &&
      values.cardiologistletter !== 'true' &&
      st.patient.obgynletter === 'true'
        ? 'Obstetrician/maternal fetal medicine clinician'
        : st.patient.obgynletter !== 'true'
        ? ''
        : ',Obstetrician/maternal fetal medicine clinician';

    var editCaseMDInfoRequest = {
      caseId: st.caseId,
      pcp: st.patient.pcp,
      pcpPhone: formatPhoneToSave(countryCode2, st.patient.pcpphone),
      pcpEmail:
        st.patient.pcpemail !== undefined ? st.patient.pcpemail.trim() : st.patient.pcpemail,
      cardiologistName: values.cardiologist,
      cardiologistPhone: formatPhoneToSave(countryCode1, values.cardiologistphone),
      cardiologistEmail:
        values.cardiologistemail !== undefined
          ? values.cardiologistemail.trim()
          : values.cardiologistemail,
      obgyn: st.patient.obgyn,
      obgynPhone: formatPhoneToSave(countryCode3, st.patient.obgynphone),
      obgynEmail:
        st.patient.obgynemail !== undefined ? st.patient.obgynemail.trim() : st.patient.obgynemail,
      sendLetter: letter1 + letter2 + letter3,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseMDInfo(editCaseMDInfoRequest));
  };

  const formikCardiologist = useFormik({
    enableReinitialize: true,
    initialValues: {
      cardiologist: st !== undefined ? st.patient.cardiologist : '',
      cardiologistphone:
        st !== undefined &&
        st.patient.cardiologistphone !== undefined &&
        st.patient.cardiologistphone !== ''
          ? st.patient.cardiologistphone.split(' ')[1] !== null
            ? st.patient.cardiologistphone.slice(st.patient.cardiologistphone.indexOf(' ') + 1)
            : st.patient.cardiologistphone
          : '',
      cardiologistemail:
        st !== undefined
          ? st.patient.cardiologistemail !== undefined
            ? st.patient.cardiologistemail.trim()
            : st.patient.cardiologistemail
          : '',
      cardiologistletter: st !== undefined ? st.patient.cardiologistletter : false
    },
    validationSchema: validateCardiologistForm,
    onSubmit: (values) => {
      // alert('Submit UpdateCardiologist API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCaseCardiologist(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveMDInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      //handleNext();
    }
  });

  // step 8
  const updateCasePCP = (values) => {
    dispatch(
      patientActions.persistPatientMDInfo(
        values.pcp,
        values.pcpphone,
        values.pcpemail !== undefined ? values.pcpemail.trim() : values.pcpemail,
        st.patient.cardiologist,
        st.patient.cardiologistphone,
        st.patient.cardiologistemail !== undefined
          ? st.patient.cardiologistemail.trim()
          : st.patient.cardiologistemail,
        st.patient.obgyn,
        st.patient.obgynphone,
        st.patient.obgynemail !== undefined ? st.patient.obgynemail.trim() : st.patient.obgynemail,
        values.pcpletter,
        st.patient.cardiologistletter,
        st.patient.obgynletter
      )
    );
    var letter1 = values.pcpletter === 'true' ? 'Primary Care Physician' : '';
    var letter2 =
      values.pcpletter === 'true' && st.patient.cardiologistletter === 'true'
        ? ',Cardiologist'
        : st.patient.cardiologistletter === 'true'
        ? 'Cardiologist'
        : '';
    var letter3 =
      values.pcpletter !== 'true' &&
      st.patient.cardiologistletter !== 'true' &&
      st.patient.obgynletter === 'true'
        ? 'Obstetrician/maternal fetal medicine clinician'
        : st.patient.obgynletter !== 'true'
        ? ''
        : ',Obstetrician/maternal fetal medicine clinician';

    var editCaseMDInfoRequest = {
      caseId: st.caseId,
      pcp: values.pcp,
      pcpPhone: formatPhoneToSave(countryCode2, values.pcpphone),
      pcpEmail: values.pcpemail !== undefined ? values.pcpemail.trim() : values.pcpemail,
      cardiologistName: st.patient.cardiologist,
      cardiologistPhone: formatPhoneToSave(countryCode1, st.patient.cardiologistphone),
      cardiologistEmail:
        st.patient.cardiologistemail !== undefined
          ? st.patient.cardiologistemail.trim()
          : st.patient.cardiologistemail,
      obgyn: st.patient.obgyn,
      obgynPhone: formatPhoneToSave(countryCode3, st.patient.obgynphone),
      obgynEmail:
        st.patient.obgynemail !== undefined ? st.patient.obgynemail.trim() : st.patient.obgynemail,
      sendLetter: letter1 + letter2 + letter3,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseMDInfo(editCaseMDInfoRequest));
  };

  const formikPCP = useFormik({
    enableReinitialize: true,
    initialValues: {
      pcp: st !== undefined ? st.patient.pcp : '',
      pcpphone:
        st !== undefined && st.patient.pcpphone !== undefined && st.patient.pcpphone !== ''
          ? st.patient.pcpphone.split(' ')[1] !== null
            ? st.patient.pcpphone.slice(st.patient.pcpphone.indexOf(' ') + 1)
            : st.patient.pcpphone
          : '',
      pcpemail:
        st !== undefined
          ? st.patient.pcpemail !== undefined
            ? st.patient.pcpemail.trim()
            : st.patient.pcpemail
          : '',
      pcpletter: st !== undefined ? st.patient.pcpletter : false
    },
    validationSchema: validatePCPForm,
    onSubmit: (values) => {
      // alert('Submit UpdateLanguage API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCasePCP(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveMDInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      //handleNext();
    }
  });

  // step 9
  const updateCaseOBGYN = (values) => {
    dispatch(
      patientActions.persistPatientMDInfo(
        st.patient.pcp,
        st.patient.pcpphone,
        st.patient.pcpemail !== undefined ? st.patient.pcpemail.trim() : st.patient.pcpemail,
        st.patient.cardiologist,
        st.patient.cardiologistphone,
        st.patient.cardiologistemail !== undefined
          ? st.patient.cardiologistemail.trim()
          : st.patient.cardiologistemail,
        values.obgyn,
        values.obgynphone,
        values.obgynemail !== undefined ? values.obgynemail.trim() : values.obgynemail,
        st.patient.pcpletter,
        st.patient.cardiologistletter,
        values.obgynletter
      )
    );
    var letter1 = st.patient.pcpletter === 'true' ? 'Primary Care Physician' : '';
    var letter2 =
      st.patient.pcpletter === 'true' && st.patient.cardiologistletter === 'true'
        ? ',Cardiologist'
        : st.patient.cardiologistletter === 'true'
        ? 'Cardiologist'
        : '';
    var letter3 =
      st.patient.pcpletter !== 'true' &&
      st.patient.cardiologistletter !== 'true' &&
      values.obgynletter === 'true'
        ? 'Obstetrician/maternal fetal medicine clinician'
        : values.obgynletter !== 'true'
        ? ''
        : ',Obstetrician/maternal fetal medicine clinician';

    var editCaseMDInfoRequest = {
      caseId: st.caseId,
      pcp: formatPhoneToSave(countryCode2, st.patient.pcp),
      pcpPhone: st.patient.pcpphone,
      pcpEmail:
        st.patient.pcpemail !== undefined ? st.patient.pcpemail.trim() : st.patient.pcpemail,
      cardiologistName: st.patient.cardiologist,
      cardiologistPhone: formatPhoneToSave(countryCode1, st.patient.cardiologistphone),
      cardiologistEmail:
        st.patient.cardiologistemail !== undefined
          ? st.patient.cardiologistemail.trim()
          : st.patient.cardiologistemail,
      obgyn: values.obgyn,
      obgynPhone: formatPhoneToSave(countryCode3, values.obgynphone),
      obgynEmail: values.obgynemail !== undefined ? values.obgynemail.trim() : values.obgynemail,
      sendLetter: letter1 + letter2 + letter3,
      createOrUpdate: 'update'
    };
    dispatch(caseActions.requestUpdateCaseMDInfo(editCaseMDInfoRequest));
  };

  const formikOBGYN = useFormik({
    enableReinitialize: true,
    initialValues: {
      obgyn: st !== undefined ? st.patient.obgyn : '',
      obgynphone:
        st !== undefined && st.patient.obgynphone !== undefined && st.patient.obgynphone !== ''
          ? st.patient.obgynphone.split(' ')[1] !== null
            ? st.patient.obgynphone.slice(st.patient.obgynphone.indexOf(' ') + 1)
            : st.patient.obgynphone
          : '',
      obgynemail:
        st !== undefined
          ? st.patient.obgynemail !== undefined
            ? st.patient.obgynemail.trim()
            : st.patient.obgynemail
          : '',
      obgynletter: st !== undefined ? st.patient.obgynletter : false
    },
    validationSchema: validateOBGYNForm,
    onSubmit: (values) => {
      // alert('Submit UpdateLanguage API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCaseOBGYN(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveMDInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      //handleNext();
    }
  });

  // step 10
  const updateCaseAdditionalInfo1 = (values) => {
    dispatch(
      patientActions.persistPatientBCHInfo(
        values.program,
        values.preferredSurgeon,
        values.preferredSurgeonName,
        values.preferredCardiologist,
        values.preferredCardiologistName,
        st.patient.inpatient,
        st.patient.whyChoose,
        st.patient.hospitalName
      )
    );
    var editCaseBCHInfoRequest = {
      caseId: st.caseId,
      program: getProgramValue(values.program),
      preferredSurgeonName: getSurgeonValue(values.preferredSurgeonName),
      preferredCardiologistName: values.preferredCardiologistName,
      cardiologistName: values.cardiologist,
      typeOfService: st.patient.inpatient === true ? 'Inpatient second opinion' : null,
      whyChosen: getWhyChooseValue(st.patient.whyChoose),
      admittedHospital: st.patient.hospitalName,
      createOrUpdate: 'update',
      email: st.email
    };
    dispatch(caseActions.requestUpdateCaseBCHInfo(editCaseBCHInfoRequest));
  };
  const formikBCHMD = useFormik({
    enableReinitialize: true,
    initialValues: {
      program: st !== undefined ? getProgramText(st.program) : '',
      preferredSurgeon: st !== undefined ? st.preferredSurgeon : false,
      preferredSurgeonName: st !== undefined ? getSurgeonName(st.preferredSurgeonName) : '',
      preferredCardiologist: st !== undefined ? st.preferredCardiologist : false,
      preferredCardiologistName: st !== undefined ? st.preferredCardiologistName : ''
    },
    validationSchema: validateBCHMDInfoForm,
    onSubmit: (values) => {
      // alert('Submit UpdateBCHMDInfo API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCaseAdditionalInfo1(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveBCHInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      //handleNext();
    }
  });

  // step 11
  const updateCaseAdditionalInfo2 = (values) => {
    dispatch(
      patientActions.persistPatientBCHInfo(
        st.program,
        st.preferredSurgeon,
        st.preferredSurgeonName,
        st.preferredCardiologist,
        st.preferredCardiologistName,
        values.inpatient,
        getWhyChooseValue(values.whyChoose),
        values.hospitalName
      )
    );
    var editCaseBCHInfoRequest = {
      caseId: st.caseId,
      program: getProgramValue(st.program),
      preferredSurgeonName: getSurgeonValue(st.preferredSurgeonName),
      preferredCardiologistName: st.preferredCardiologistName,
      cardiologistName: st.cardiologist,
      typeOfService: values.inpatient === 'true' ? 'Inpatient second opinion' : null,
      whyChosen: getWhyChooseValue(values.whyChoose),
      admittedHospital: values.hospitalName,
      createOrUpdate: 'update',
      email: st.email
    };
    dispatch(caseActions.requestUpdateCaseBCHInfo(editCaseBCHInfoRequest));
  };
  const formikOtherInfo = useFormik({
    enableReinitialize: true,
    initialValues: {
      inpatient: st !== undefined ? st.inpatient : false,
      whyChoose: st !== undefined ? getWhyChooseText(st.whyChoose) : '',
      hospitalName: st !== undefined ? st.hospitalName : ''
    },
    validationSchema: validateOtherInfoForm,
    onSubmit: (values) => {
      // alert('Submit UpdateBCHMDInfo API\n' + JSON.stringify(values, null, 2));
      console.log(values);
      updateCaseAdditionalInfo2(values);
      // reset flag
      dispatch(caseActions.setDataUpdated(false));
      setSaveBCHInfoSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
      handleDone();
      //handleNext();
    }
  });
  // others
  const handleNext = () => {
    if (st.activeStep === 7 && option !== 'your fetus') {
      dispatch(caseActions.setActiveStep(st.activeStep + 2));
    } else {
      dispatch(caseActions.setActiveStep(st.activeStep + 1));
    }
  };

  const handleBack = () => {
    if (st.activeStep === 9 && option !== 'your fetus') {
      dispatch(caseActions.setActiveStep(st.activeStep - 2));
    } else {
      dispatch(caseActions.setActiveStep(st.activeStep - 1));
    }
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        navigate('/sop2web/home');
      }
    }
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleDone = () => {
    navigate('/sop2web/home');
  };

  const SaveInfo = () => {
    switch (st.activeStep) {
      case 0:
      case 1:
        break;
      case 2:
        // updateCaseStory(formikStory.values);
        break;
      case 4:
        updateCaseAddress(formikAddress.values);
        break;
      /*case 4:
        updateCaseEmailPhone(formikEmailPhone.values);
        break;*/
      case 5:
        updateCaseLanguage(formikLanguage.values);
        break;
      case 6:
        updateCaseCardiologist(formikCardiologist.values);
        break;
      case 7:
        updateCasePCP(formikPCP.values);
        break;
      case 8:
        updateCaseOBGYN(formikOBGYN.values);
        break;
      case 9:
        updateCaseAdditionalInfo1(formikBCHMD.values);
        break;
      case 10:
        updateCaseAdditionalInfo2(formikOtherInfo.values);
        break;
      default:
        return;
    }
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleViewCasesNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialogFromMenu(true);
    } else {
      navigate('/sop2web/home');
    }
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleNewCaseNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialogFromMenu(true);
    } else {
      dispatch(caseActions.clearCase());
      dispatch(caseActions.setShowWelcome(false));
      navigate('/sop2web/newcase');
    }
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleRequestViewNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      navigate('/sop2web/requestview');
    }
  };

  const handleProfileNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialogFromMenu(true);
    } else {
      navigate('/sop2web/profile');
    }
    // reset error when navigate out
    if (
      st.createcaseerror !== '' ||
      st.updatebasicerror !== '' ||
      st.updatecontacterror !== '' ||
      st.updatemderror !== '' ||
      st.updatebcherror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleLogoutNavMenu = () => {
    if (st.dataUpdated) {
      setShowDialog(true);
    } else {
      dispatch(logoutAction.logOut());
      navigate('/sop2web/signin');
    }
  };

  const handleCancelFromMenu = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialogFromMenu(false);
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
  };

  return (
    <ThemeProvider theme={appTheme}>
      <AppBar position="static" style={{ background: '#003087', height: 80 }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
              <BCHLogoSOP />
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit">
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' }
                }}>
                <MenuItem key="View My Cases" onClick={handleViewCasesNavMenu}>
                  <BadgeIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">View My Cases</Typography>
                </MenuItem>
                <MenuItem key="Request New Case" onClick={handleNewCaseNavMenu}>
                  <CreateNewFolderIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request New Case</Typography>
                </MenuItem>
                <MenuItem key="Request to View" onClick={handleRequestViewNavMenu}>
                  <Pageview style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Request to View</Typography>
                </MenuItem>
                {false && (
                  <MenuItem key="Upload File">
                    <DriveFolderUploadRounded style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                    <Typography textAlign="center">Upload File</Typography>
                  </MenuItem>
                )}
              </Menu>
            </Box>
            <Dialog
              open={showDialogFromMenu}
              onClose={handleCancelFromMenu}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  You are about to leave the form and the form contain unsaved data. Do you want to
                  save?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCancelFromMenu}>No</Button>
                <Button
                  onClick={() => {
                    // reset flag
                    dispatch(caseActions.setDataUpdated(false));
                    setShowDialogFromMenu(false);
                    SaveInfo();
                  }}
                  autoFocus>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
              <BCHLogoSOP />
            </Typography>
            <Box
              sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' }, gap: 4, ml: 3 }}>
              <Button
                key="View My Cases"
                onClick={handleViewCasesNavMenu}
                size="iconSizeLarge"
                startIcon={<BadgeIcon />}
                sx={{ my: 2, color: 'white' }}>
                View My Cases
              </Button>
              <Button
                key="Request New Case"
                onClick={handleNewCaseNavMenu}
                size="iconSizeLarge"
                startIcon={<CreateNewFolderIcon />}
                sx={{ my: 0, color: 'white' }}>
                Request New Case
              </Button>
              <Button
                key="Request to View"
                size="iconSizeLarge"
                onClick={handleRequestViewNavMenu}
                startIcon={<Pageview />}
                sx={{ my: 0, color: 'white' }}>
                Request to View
              </Button>
              {false && (
                <Button
                  key="Upload File"
                  size="iconSizeLarge"
                  onClick={handleNewCaseNavMenu}
                  startIcon={<DriveFolderUploadRounded />}
                  sx={{ my: 0, color: 'white' }}>
                  Upload File
                </Button>
              )}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Click to open menu">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircle style={{ fill: '#FFFFFF' }} sx={{ fontSize: 50 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                <MenuItem key="Profile" onClick={handleProfileNavMenu}>
                  <Typography textAlign="center">Profile</Typography>
                </MenuItem>
                <MenuItem key="Logout" onClick={handleLogoutNavMenu}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Grid container component="main" sx={styles.gridContainerStyle}>
        {/* <CssBaseline /> */}
        {/* <PerfectScrollbar component="div"> */}
        {st.showWelcome === false && (
          <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
            <Box sx={styles.formCardContainerStyle}>
              {showContactMessage === false &&
                showCaseAlreadyLinked === false &&
                showCaseAccessRequested === false && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, width: 450 }}>
                    <Dialog
                      open={showDialog}
                      onClose={handleCancelToHome}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description">
                      <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          You are about to leave the form and the form contain unsaved data. Do you
                          want to save?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCancelToHome}>No</Button>
                        <Button
                          onClick={() => {
                            // reset flag
                            dispatch(caseActions.setDataUpdated(false));
                            // reset fromMenu
                            // setFromMenu(false);
                            setShowDialog(false);
                            SaveInfo();
                            dispatch(caseActions.setViewSummary(true));
                            navigate('/sop2web/home');
                          }}
                          autoFocus>
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Button size="large" onClick={handleHome}>
                      <KeyboardArrowLeft />
                      Home
                    </Button>
                  </Box>
                )}
              {showContactMessage === false &&
                showCaseAlreadyLinked === false &&
                showCaseAccessRequested === false && (
                  <Stack direction="row" sx={styles.formCardTitleStyle}>
                    <AddCircleIcon color="primary" style={{ fontSize: 50 }} />
                    <Typography sx={{ my: 1, fontSize: 20, fontWeight: '700' }}>
                      Case Creation
                    </Typography>
                  </Stack>
                )}
              <Box sx={styles.containerStyle}>
                {st.activeStep === 0 && showContactMessage === false && (
                  <Box component="form" noValidate>
                    <Box sx={{ justifyContent: 'flex-start', border: 0, mt: 2, width: 400 }}>
                      <Typography
                        style={{
                          color: '#021D4E',
                          fontWeight: '500',
                          fontSize: 16,
                          textAlign: 'left'
                        }}>
                        Who is the second opinion for?
                      </Typography>
                      <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                        <FormControl>
                          <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                          <RadioGroup
                            aria-labelledby="option"
                            name="option"
                            value={option}
                            onChange={handleCaseTypeChange}>
                            {CaseType.PROP.map((res) => {
                              return (
                                <Box key={res.key}>
                                  <FormControlLabel
                                    value={res.value}
                                    control={<Radio />}
                                    label={
                                      <Typography
                                        style={{
                                          color: '#021D4E',
                                          fontWeight: '500',
                                          fontSize: 15,
                                          textAlign: 'left'
                                        }}>
                                        {res.text}
                                      </Typography>
                                    }
                                  />
                                </Box>
                              );
                            })}
                          </RadioGroup>
                        </FormControl>
                      </Box>
                      {showMother && (
                        <Box sx={{ mb: 4, ml: 2 }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox checked={mother} onChange={handleMotherCheckboxChange} />
                              }
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  I am the pregnant mother
                                </Typography>
                              }
                            />
                          </FormGroup>
                        </Box>
                      )}
                      {showRelative && (
                        <Box sx={{ mb: 4, ml: 2 }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={relative}
                                  onChange={handleRelativeCheckboxChange}
                                />
                              }
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  I am a relative
                                </Typography>
                              }
                            />
                          </FormGroup>
                        </Box>
                      )}
                    </Box>

                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4
                      }}
                      nextButton={
                        <Button size="large" variant="contained" onClick={handleCaseTypeNext}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleCaseTypeBack}
                          disabled={st.activeStep >= 4}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 1 &&
                  showCaseAlreadyLinked === false &&
                  showCaseAccessRequested === false && (
                    <Box component="form" noValidate>
                      {option === 'your child' && (
                        <Typography sx={styles.subTitleStyle}>Tell us about your child</Typography>
                      )}
                      {option === 'yourself' && (
                        <Typography sx={styles.subTitleStyle}>Tell us about yourself</Typography>
                      )}
                      {option === 'your fetus' && mother === true && (
                        <Typography sx={styles.subTitleStyle}>Tell us about yourself</Typography>
                      )}
                      {option === 'your fetus' && mother === false && (
                        <Typography sx={styles.subTitleStyle}>Tell us about the mother</Typography>
                      )}
                      {option === 'other relative' && (
                        <Typography sx={styles.subTitleStyle}>Tell us about the patient</Typography>
                      )}
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          // alignItems: 'center',
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 0,
                          width: 400
                        }}>
                        <TextField
                          // size="small"
                          // variant="standard"
                          margin="dense"
                          required
                          fullWidth
                          id="firstName"
                          label="First name"
                          name="firstName"
                          // value={propsForm.values.firstName}
                          autoComplete="firstName"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          autoFocus
                          value={formikAboutYou.values.firstName}
                          onChange={formikAboutYou.handleChange}
                          error={
                            formikAboutYou.touched.firstName &&
                            Boolean(formikAboutYou.errors.firstName)
                          }
                          helperText={
                            formikAboutYou.touched.firstName && formikAboutYou.errors.firstName
                          }
                        />
                        <TextField
                          // size="small"
                          // variant="standard"
                          margin="dense"
                          required
                          fullWidth
                          id="lastName"
                          label="Last name"
                          name="lastName"
                          autoComplete="lastName"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAboutYou.values.lastName}
                          onChange={formikAboutYou.handleChange}
                          error={
                            formikAboutYou.touched.lastName &&
                            Boolean(formikAboutYou.errors.lastName)
                          }
                          helperText={
                            formikAboutYou.touched.lastName && formikAboutYou.errors.lastName
                          }
                        />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Box sx={{ mt: 2 }}>
                            {!onMobile && (
                              <DatePicker
                                openTo="year"
                                views={['year', 'month', 'day']}
                                floatingLabelText="Date"
                                label="Date of birth"
                                size="small"
                                id="dob"
                                maxDate={new Date()}
                                value={formikAboutYou.values.dob}
                                onChange={(newvalue) =>
                                  formikAboutYou.setFieldValue('dob', dateToString(newvalue))
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    fullWidth
                                    // name="dob"
                                    inputProps={{ style: { fontSize: 16 } }}
                                    InputLabelProps={{ style: { fontSize: 14 } }}
                                    value={formikAboutYou.values.dob}
                                    onChange={(value) =>
                                      formikAboutYou.setFieldValue('dob', dateToString(value))
                                    }
                                    error={
                                      formikAboutYou.touched.dob &&
                                      Boolean(formikAboutYou.errors.dob)
                                    }
                                    helperText={
                                      formikAboutYou.touched.dob && formikAboutYou.errors.dob
                                    }
                                  />
                                )}
                              />
                            )}
                            {onMobile && (
                              /*<TextField
                            id="date"
                            label="Date of birth"
                            type="date"
                            required
                            fullWidth
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            maxDate={new Date()}
                            value={formikAboutYou.values.dob}
                            // onChange={(value) => formikAboutYou.setFieldValue('dob', value)}
                            onChange={formikAboutYou.handleChange}
                            error={formikAboutYou.touched.dob && Boolean(formikAboutYou.errors.dob)}
                            helperText={formikAboutYou.touched.dob && formikAboutYou.errors.dob}
                          />*/
                              <DatePicker
                                views={['day']}
                                label="Date of birth"
                                maxDate={new Date()}
                                value={formikAboutYou.values.dob}
                                onChange={(newValue) => {
                                  formikAboutYou.setFieldValue('dob', newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    fullWidth
                                    helperText={'mm/dd/yyyy'}
                                  />
                                )}
                              />
                            )}
                          </Box>
                        </LocalizationProvider>
                        {option === 'your fetus' && (
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Box sx={{ mt: 2 }}>
                              {!onMobile && (
                                <DatePicker
                                  openTo="year"
                                  views={['year', 'month', 'day']}
                                  label="Baby due date"
                                  size="small"
                                  minDate={new Date()}
                                  // inputFormat="MMM dd yyyy"
                                  value={formikAboutYou.values.dueDate}
                                  onChange={(value) =>
                                    formikAboutYou.setFieldValue('dueDate', dateToString(value))
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      // variant="standard"
                                      // size="large"
                                      required
                                      fullWidth
                                      inputProps={{ style: { fontSize: 16 } }}
                                      InputLabelProps={{ style: { fontSize: 14 } }}
                                      value={formikAboutYou.values.dueDate}
                                      onChange={(value) =>
                                        formikAboutYou.setFieldValue('dueDate', dateToString(value))
                                      }
                                      error={
                                        formikAboutYou.touched.dueDate &&
                                        Boolean(formikAboutYou.errors.dueDate)
                                      }
                                      helperText={
                                        formikAboutYou.touched.dueDate &&
                                        formikAboutYou.errors.dueDate
                                      }
                                    />
                                  )}
                                />
                              )}
                              {onMobile && (
                                /*<TextField
                              label="Baby due date"
                              type="date"
                              required
                              fullWidth
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              minDate={new Date()}
                              value={formikAboutYou.values.dueDate}
                              onChange={(value) =>
                                formikAboutYou.setFieldValue('dueDate', dateToString(value))
                              }
                              error={
                                formikAboutYou.touched.dueDate &&
                                Boolean(formikAboutYou.errors.dueDate)
                              }
                              helperText={
                                formikAboutYou.touched.dueDate && formikAboutYou.errors.dueDate
                              }
                            />*/
                                <DatePicker
                                  views={['day']}
                                  label="Baby due date"
                                  minDate={new Date()}
                                  value={formikAboutYou.values.dueDate}
                                  onChange={(newValue) => {
                                    formikAboutYou.setFieldValue('dueDate', newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} fullWidth helperText={'mm/dd/yyyy'} />
                                  )}
                                />
                              )}
                            </Box>
                          </LocalizationProvider>
                        )}
                        {option !== 'your fetus' && (
                          <Box sx={{ mb: 2, mt: 2 }}>
                            <FormControl>
                              <FormLabel id="gender-group">
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 16,
                                    textAlign: 'left'
                                  }}>
                                  Gender&#x2a;
                                </Typography>
                              </FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="gender"
                                name="gender"
                                id="gender"
                                value={formikAboutYou.values.gender}
                                onChange={formikAboutYou.handleChange}>
                                {GENDER.map((res) => {
                                  return (
                                    <Box key={res.key}>
                                      <FormControlLabel
                                        value={res.value}
                                        control={<Radio />}
                                        label={
                                          <Typography
                                            style={{
                                              color: '#021D4E',
                                              fontWeight: '500',
                                              fontSize: 18,
                                              textAlign: 'left'
                                            }}>
                                            {res.text}
                                          </Typography>
                                        }
                                      />
                                    </Box>
                                  );
                                })}
                              </RadioGroup>

                              {formikAboutYou.touched.gender &&
                                Boolean(formikAboutYou.errors.gender) && (
                                  <Typography style={styles.errorText}>
                                    {formikAboutYou.errors.gender}
                                  </Typography>
                                )}
                            </FormControl>
                          </Box>
                        )}
                      </Box>
                      <Typography style={styles.errorText}>{st.createcaseerror}</Typography>
                      <MobileStepper
                        variant="dots"
                        steps={11}
                        position="static"
                        activeStep={st.activeStep}
                        sx={{
                          maxWidth: 400,
                          flexGrow: 1,
                          backgroundColor: '#FFFFFF',
                          mb: 4
                        }}
                        nextButton={
                          <Button
                            size="large"
                            variant="contained"
                            onClick={formikAboutYou.handleSubmit}
                            disabled={loading || st.activeStep === 11}>
                            Next
                            {theme.direction === 'rtl' ? (
                              <KeyboardArrowLeft />
                            ) : (
                              <KeyboardArrowRight />
                            )}
                          </Button>
                        }
                        backButton={
                          <Button
                            size="large"
                            // variant="contained"
                            onClick={handleBack}
                            disabled={st.activeStep >= 4}>
                            {theme.direction === 'rtl' ? (
                              <KeyboardArrowRight />
                            ) : (
                              <KeyboardArrowLeft />
                            )}
                            Back
                          </Button>
                        }
                      />
                    </Box>
                  )}

                {st.activeStep === 2 && (
                  <Box component="form">
                    <Box sx={{ justifyContent: 'flex-start', border: 0, mt: 2, width: 450 }}>
                      <Typography sx={styles.subTitleStyle}>Tell us your story</Typography>

                      {/* <PerfectScrollbar */}
                      {/* style={{ height: '100%', maxHeight: 'calc(60vh)', overflowX: 'hidden' }}> */}
                      <Box sx={{ mb: 4, ml: 0, mt: 2 }}>
                        <TextareaAutosize
                          aria-label="story"
                          minRows={10}
                          placeholder="Tell us your story"
                          required
                          label="Story"
                          style={{
                            width: 450,
                            fontSize: 16,
                            resize: 'vertical',
                            maxHeight: '400px',
                            overflow: 'auto',
                            pb: '300px'
                          }}
                          autoFocus
                          id="story"
                          name="story"
                          value={formikStory.values.story}
                          onChange={(e) => {
                            formikStory.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                        />
                        {formikStory.touched.story && Boolean(formikStory.errors.story) && (
                          <Typography style={styles.errorText}>
                            {formikStory.errors.story}
                          </Typography>
                        )}
                      </Box>
                      {/* </PerfectScrollbar> */}
                    </Box>
                    <Typography style={styles.errorText}>{st.updatebasicerror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 500,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikStory.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep >= 4}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 4 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 400
                      }}>
                      <Typography sx={styles.subTitleStyle}>How can we reach you?</Typography>
                      <Box sx={{ mb: 0, ml: 0, mt: 2 }}>
                        {/* <Typography sx={{ my: 0, fontSize: 18, fontWeight: '400' }}>Address</Typography> */}
                        <Autocomplete
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="country"
                          label="Primary country of residence"
                          sx={{ width: 400 }}
                          options={countries}
                          autoHighlight
                          getOptionLabel={(option) => {
                            console.log(option);
                            return option.label !== undefined
                              ? option.label
                              : option !== undefined
                              ? option
                              : st.localCountryName;
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                              {...props}>
                              <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                              />
                              {option.label} ({option.code})
                            </Box>
                          )}
                          renderInput={(params) => (
                            <Box>
                              <TextField
                                {...params}
                                label="Primary country of residence"
                                size="small"
                                // variant="standard"
                                margin="dense"
                                fullWidth
                                name="country"
                                inputProps={{
                                  ...params.inputProps,
                                  style: { fontSize: 16 }
                                }}
                                InputLabelProps={{
                                  style: { fontSize: 14 }
                                }}
                              />
                            </Box>
                          )}
                          value={formikAddress.values.country}
                          isOptionEqualToValue={(option, value) => option.label === value}
                          onChange={(e, value) => {
                            console.log(value);
                            formikAddress.setFieldValue('country', value.label);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="addressline1"
                          label="Address line 1"
                          name="addressline1"
                          autoComplete="addressline1"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.addressline1}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.addressline1 &&
                            Boolean(formikAddress.errors.addressline1)
                          }
                          helperText={
                            formikAddress.touched.addressline1 && formikAddress.errors.addressline1
                          }
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="addressline2"
                          label="Address line 2"
                          name="addressline2"
                          autoComplete="addressline2"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.addressline2}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.addressline2 &&
                            Boolean(formikAddress.errors.addressline2)
                          }
                          helperText={
                            formikAddress.touched.addressline2 && formikAddress.errors.addressline2
                          }
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="city"
                          label="City"
                          name="city"
                          autoComplete="city"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.city}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={formikAddress.touched.city && Boolean(formikAddress.errors.city)}
                          helperText={formikAddress.touched.city && formikAddress.errors.city}
                        />
                        {formikAddress.values.country !== 'United States' && (
                          <TextField
                            size="small"
                            variant="standard"
                            margin="dense"
                            fullWidth
                            id="province"
                            label="Province"
                            name="province"
                            autoComplete="province"
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            value={formikAddress.values.province}
                            onChange={(e) => {
                              formikAddress.handleChange(e);
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            error={
                              formikAddress.touched.province &&
                              Boolean(formikAddress.errors.province)
                            }
                            helperText={
                              formikAddress.touched.province && formikAddress.errors.province
                            }
                          />
                        )}
                        {formikAddress.values.country === 'United States' && (
                          <Autocomplete
                            id="state"
                            sx={{ width: 400 }}
                            options={US_STATES_SORT_BY_NAME}
                            autoHighlight
                            getOptionLabel={(option) => {
                              console.log(option);
                              return option.text !== undefined
                                ? option.text
                                : option !== undefined
                                ? option
                                : '';
                            }}
                            renderOption={(props, option) => (
                              <Box
                                component="li"
                                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                {...props}>
                                {option.text}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <Box>
                                <TextField
                                  {...params}
                                  label="State"
                                  size="small"
                                  // variant="standard"
                                  margin="dense"
                                  fullWidth
                                  name="state"
                                  inputProps={{
                                    ...params.inputProps,
                                    style: { fontSize: 16 }
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: 14 }
                                  }}
                                />
                              </Box>
                            )}
                            value={formikAddress.values.state}
                            isOptionEqualToValue={(option, value) => option.text === value}
                            onChange={(e, value) => {
                              console.log(value);
                              formikAddress.setFieldValue(
                                'state',
                                value !== null ? value.text : ''
                              );
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                          />
                        )}
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="zip"
                          label="Zip code"
                          name="zip"
                          autoComplete="zip"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.zip}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={formikAddress.touched.zip && Boolean(formikAddress.errors.zip)}
                          helperText={formikAddress.touched.zip && formikAddress.errors.zip}
                        />
                        {!showAddress2 && (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              mt: 1
                            }}
                            onClick={addAddress}>
                            <AddIcon
                              color="#003087"
                              style={{ color: '#003087', fontSize: 16, mt: 1 }}
                            />
                            <Typography sx={{ color: '#003087', fontSize: 14, fontWeight: '500' }}>
                              Add address
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                    {showAddress2 && (
                      <Box sx={{ mb: 0, ml: 0, mt: 2 }}>
                        <Autocomplete
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="secondaryCountry"
                          label="Secondary country of residence"
                          sx={{ width: 400 }}
                          options={countries}
                          autoHighlight
                          getOptionLabel={(option) => {
                            console.log(option);
                            return option.label !== undefined
                              ? option.label
                              : option !== undefined
                              ? option
                              : st.localCountryName;
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                              {...props}>
                              <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                              />
                              {option.label} ({option.code})
                            </Box>
                          )}
                          renderInput={(params) => (
                            <Box>
                              <TextField
                                {...params}
                                label="Secondary country of residence"
                                size="small"
                                // variant="standard"
                                margin="dense"
                                fullWidth
                                name="secondaryCountry"
                                inputProps={{
                                  ...params.inputProps,
                                  style: { fontSize: 16 }
                                }}
                                InputLabelProps={{
                                  style: { fontSize: 14 }
                                }}
                              />
                            </Box>
                          )}
                          value={formikAddress.values.secondaryCountry}
                          isOptionEqualToValue={(option, value) => option.label === value}
                          onChange={(e, value) => {
                            console.log(value);
                            formikAddress.setFieldValue('secondaryCountry', value.label);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="secondaryAddressline1"
                          label="Secondary Address line 1"
                          name="secondaryAddressline1"
                          autoComplete="secondaryAddressline1"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.secondaryAddressline1}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.secondaryAddressline1 &&
                            Boolean(formikAddress.errors.secondaryAddressline1)
                          }
                          helperText={
                            formikAddress.touched.secondaryAddressline1 &&
                            formikAddress.errors.secondaryAddressline1
                          }
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="secondaryAddressline2"
                          label="Secondary Address line 2"
                          name="secondaryAddressline2"
                          autoComplete="secondaryAddressline2"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.secondaryAddressline2}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.secondaryAddressline2 &&
                            Boolean(formikAddress.errors.secondaryAddressline2)
                          }
                          helperText={
                            formikAddress.touched.secondaryAddressline2 &&
                            formikAddress.errors.secondaryAddressline2
                          }
                        />
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="secondaryCity"
                          label="Secondary City"
                          name="secondaryCity"
                          autoComplete="secondaryCity"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.secondaryCity}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.secondaryCity &&
                            Boolean(formikAddress.errors.secondaryCity)
                          }
                          helperText={
                            formikAddress.touched.secondaryCity &&
                            formikAddress.errors.secondaryCity
                          }
                        />
                        {formikAddress.values.secondaryCountry !== 'United States' && (
                          <TextField
                            size="small"
                            variant="standard"
                            margin="dense"
                            fullWidth
                            id="secondaryProvince"
                            label="Secondary Province"
                            name="secondaryProvince"
                            autoComplete="secondaryProvince"
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            value={formikAddress.values.secondaryProvince}
                            onChange={(e) => {
                              formikAddress.handleChange(e);
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            error={
                              formikAddress.touched.secondaryProvince &&
                              Boolean(formikAddress.errors.secondaryProvince)
                            }
                            helperText={
                              formikAddress.touched.secondaryProvince &&
                              formikAddress.errors.secondaryProvince
                            }
                          />
                        )}
                        {formikAddress.values.secondaryCountry === 'United States' && (
                          <Autocomplete
                            id="secondaryState"
                            sx={{ width: 400 }}
                            options={US_STATES_SORT_BY_NAME}
                            autoHighlight
                            getOptionLabel={(option) => {
                              console.log(option);
                              return option.text !== undefined
                                ? option.text
                                : option !== undefined
                                ? option
                                : '';
                            }}
                            renderOption={(props, option) => (
                              <Box
                                component="li"
                                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                {...props}>
                                {option.text}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <Box>
                                <TextField
                                  {...params}
                                  label="Secondary State"
                                  size="small"
                                  // variant="standard"
                                  margin="dense"
                                  fullWidth
                                  name="secondaryState"
                                  inputProps={{
                                    ...params.inputProps,
                                    style: { fontSize: 16 }
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: 14 }
                                  }}
                                />
                              </Box>
                            )}
                            value={formikAddress.values.secondaryState}
                            isOptionEqualToValue={(option, value) => option.text === value}
                            onChange={(e, value) => {
                              console.log(value);
                              formikAddress.setFieldValue(
                                'secondaryState',
                                value !== null ? value.text : ''
                              );
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                          />
                        )}
                        <TextField
                          size="small"
                          variant="standard"
                          margin="dense"
                          fullWidth
                          id="secondaryZip"
                          label="Secondary Zip code"
                          name="secondaryZip"
                          autoComplete="secondaryZip"
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          value={formikAddress.values.secondaryZip}
                          onChange={(e) => {
                            formikAddress.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          error={
                            formikAddress.touched.secondaryZip &&
                            Boolean(formikAddress.errors.secondaryZip)
                          }
                          helperText={
                            formikAddress.touched.secondaryZip && formikAddress.errors.secondaryZip
                          }
                        />
                      </Box>
                    )}
                    <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikAddress.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep >= 4}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 3 &&
                  showCaseAlreadyLinked === false &&
                  showCaseAccessRequested === false && (
                    <Box component="form">
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: 0,
                          mt: 0,
                          width: 400
                        }}>
                        <Typography sx={styles.subTitleStyle}>How can we reach you?</Typography>
                        <Box sx={{ mb: 0, ml: 0, mt: 2 }}>
                          <TextField
                            size="small"
                            variant="standard"
                            margin="dense"
                            fullWidth
                            id="email"
                            label="Primary Email"
                            name="email"
                            autoComplete="email"
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            value={formikEmailPhone.values.email}
                            onChange={(e) => {
                              formikEmailPhone.handleChange(e);
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            error={
                              formikEmailPhone.touched.email &&
                              Boolean(formikEmailPhone.errors.email)
                            }
                            helperText={
                              formikEmailPhone.touched.email && formikEmailPhone.errors.email
                            }
                          />
                          {showEmail2 && (
                            <TextField
                              size="small"
                              variant="standard"
                              margin="dense"
                              fullWidth
                              id="email2"
                              label="Secondary Email"
                              name="email2"
                              autoComplete="email2"
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              value={formikEmailPhone.values.email2}
                              onChange={(e) => {
                                formikEmailPhone.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={
                                formikEmailPhone.touched.email2 &&
                                Boolean(formikEmailPhone.errors.email2)
                              }
                              helperText={
                                formikEmailPhone.touched.email2 && formikEmailPhone.errors.email2
                              }
                            />
                          )}
                          {!showEmail2 && (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                mt: 1
                              }}
                              onClick={addEmail}>
                              <AddIcon
                                color="#003087"
                                style={{ color: '#003087', fontSize: 16, mt: 1 }}
                              />
                              <Typography
                                sx={{ color: '#003087', fontSize: 14, fontWeight: '500' }}>
                                Add e-mail
                              </Typography>
                            </Box>
                          )}
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              marginTop: 15,
                              marginBottom: 15,
                              textAlign: 'left'
                            }}>
                            What are phone numbers that we can reach you?
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            <MuiPhoneNumber
                              fullWidth
                              size="small"
                              defaultCountry={'us'}
                              variant="standard"
                              inputProps={{ style: { fontSize: 16 } }}
                              sx={{ mt: 2 }}
                              id="phone"
                              value={formikEmailPhone.values.phone}
                              onChange={(value, country) => {
                                console.log(country.dialCode);
                                if (
                                  value.includes(' ') &&
                                  countryCodePhone1 !== value.split(' ')[0]
                                ) {
                                  setCountryCodePhone1(value.split(' ')[0]);
                                  formikEmailPhone.setFieldValue('phone', value);
                                } else {
                                  setCountryCodePhone1(country.dialCode);
                                  formikEmailPhone.setFieldValue('phone', value);
                                }
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={
                                formikEmailPhone.touched.phone &&
                                Boolean(formikEmailPhone.errors.phone)
                              }
                              helperText={
                                formikEmailPhone.touched.phone && formikEmailPhone.errors.phone
                              }
                            />
                            <Autocomplete
                              size="small"
                              variant="standard"
                              margin="dense"
                              id="phonetype"
                              sx={{ width: 400 }}
                              options={PHONES}
                              autoHighlight
                              getOptionLabel={(option) => {
                                console.log(option);
                                return option.text !== undefined
                                  ? option.text
                                  : option !== undefined
                                  ? option
                                  : '';
                              }}
                              renderOption={(props, option) => (
                                <Box
                                  component="li"
                                  sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                  {...props}>
                                  {option.text}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <Box>
                                  <TextField
                                    {...params}
                                    label="Phone type"
                                    // size="small"
                                    // variant="standard"
                                    margin="dense"
                                    fullWidth
                                    name="phonetype"
                                    inputProps={{
                                      ...params.inputProps,
                                      style: { fontSize: 16 }
                                    }}
                                    InputLabelProps={{
                                      style: { fontSize: 14 }
                                    }}
                                  />
                                </Box>
                              )}
                              value={formikEmailPhone.values.phonetype}
                              isOptionEqualToValue={(option, value) => option.text === value}
                              onChange={(e, value) => {
                                console.log(value);
                                formikEmailPhone.setFieldValue(
                                  'phonetype',
                                  value !== null ? value.text : ''
                                );
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                            />
                          </Stack>
                          {showPhone2 && (
                            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                              <MuiPhoneNumber
                                fullWidth
                                size="small"
                                defaultCountry={'us'}
                                variant="standard"
                                inputProps={{ style: { fontSize: 16 } }}
                                sx={{ mt: 2 }}
                                id="phone2"
                                value={formikEmailPhone.values.phone2}
                                onChange={(value, country) => {
                                  console.log(country.dialCode);
                                  if (
                                    value.includes(' ') &&
                                    countryCodePhone2 !== value.split(' ')[0]
                                  ) {
                                    setCountryCodePhone2(value.split(' ')[0]);
                                    formikEmailPhone.setFieldValue('phone2', value);
                                  } else {
                                    setCountryCodePhone2(country.dialCode);
                                    formikEmailPhone.setFieldValue('phone2', value);
                                  }
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                                error={
                                  formikEmailPhone.touched.phone2 &&
                                  Boolean(formikEmailPhone.errors.phone2)
                                }
                                helperText={
                                  formikEmailPhone.touched.phone2 && formikEmailPhone.errors.phone2
                                }
                              />
                              <Autocomplete
                                size="small"
                                variant="standard"
                                margin="dense"
                                id="phonetype2"
                                sx={{ width: 400 }}
                                options={PHONES}
                                autoHighlight
                                getOptionLabel={(option) => {
                                  console.log(option);
                                  return option.text !== undefined
                                    ? option.text
                                    : option !== undefined
                                    ? option
                                    : '';
                                }}
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                    {...props}>
                                    {option.text}
                                  </Box>
                                )}
                                renderInput={(params) => (
                                  <Box>
                                    <TextField
                                      {...params}
                                      label="Phone type"
                                      // size="small"
                                      // variant="standard"
                                      margin="dense"
                                      fullWidth
                                      name="phonetype2"
                                      inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: 16 }
                                      }}
                                      InputLabelProps={{
                                        style: { fontSize: 14 }
                                      }}
                                    />
                                  </Box>
                                )}
                                value={formikEmailPhone.values.phonetype2}
                                isOptionEqualToValue={(option, value) => option.text === value}
                                onChange={(e, value) => {
                                  console.log(value);
                                  formikEmailPhone.setFieldValue(
                                    'phonetype2',
                                    value !== null ? value.text : ''
                                  );
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                              />
                            </Stack>
                          )}
                          {showPhone3 && (
                            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                              <MuiPhoneNumber
                                fullWidth
                                size="small"
                                defaultCountry={'us'}
                                variant="standard"
                                inputProps={{ style: { fontSize: 16 } }}
                                sx={{ mt: 2 }}
                                id="phone3"
                                value={formikEmailPhone.values.phone3}
                                onChange={(value, country) => {
                                  console.log(country.dialCode);
                                  if (
                                    value.includes(' ') &&
                                    countryCodePhone3 !== value.split(' ')[0]
                                  ) {
                                    setCountryCodePhone3(value.split(' ')[0]);
                                    formikEmailPhone.setFieldValue('phone3', value);
                                  } else {
                                    setCountryCodePhone3(country.dialCode);
                                    formikEmailPhone.setFieldValue('phone3', value);
                                  }
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                                error={
                                  formikEmailPhone.touched.phone3 &&
                                  Boolean(formikEmailPhone.errors.phone3)
                                }
                                helperText={
                                  formikEmailPhone.touched.phone3 && formikEmailPhone.errors.phone3
                                }
                              />
                              <Autocomplete
                                size="small"
                                variant="standard"
                                margin="dense"
                                id="phonetype3"
                                sx={{ width: 400 }}
                                options={PHONES}
                                autoHighlight
                                getOptionLabel={(option) => {
                                  console.log(option);
                                  return option.text !== undefined
                                    ? option.text
                                    : option !== undefined
                                    ? option
                                    : '';
                                }}
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                    {...props}>
                                    {option.text}
                                  </Box>
                                )}
                                renderInput={(params) => (
                                  <Box>
                                    <TextField
                                      {...params}
                                      label="Phone type"
                                      // size="small"
                                      // variant="standard"
                                      margin="dense"
                                      fullWidth
                                      name="phonetype3"
                                      inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: 16 }
                                      }}
                                      InputLabelProps={{
                                        style: { fontSize: 14 }
                                      }}
                                    />
                                  </Box>
                                )}
                                value={formikEmailPhone.values.phonetype3}
                                isOptionEqualToValue={(option, value) => option.text === value}
                                onChange={(e, value) => {
                                  console.log(value);
                                  formikEmailPhone.setFieldValue(
                                    'phonetype3',
                                    value !== null ? value.text : ''
                                  );
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                              />
                            </Stack>
                          )}
                          {showPhone4 && (
                            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                              <MuiPhoneNumber
                                fullWidth
                                size="small"
                                defaultCountry={'us'}
                                variant="standard"
                                inputProps={{ style: { fontSize: 16 } }}
                                sx={{ mt: 2 }}
                                id="phone4"
                                value={formikEmailPhone.values.phone4}
                                onChange={(value, country) => {
                                  console.log(country.dialCode);
                                  if (
                                    value.includes(' ') &&
                                    countryCodePhone4 !== value.split(' ')[0]
                                  ) {
                                    setCountryCodePhone4(value.split(' ')[0]);
                                    formikEmailPhone.setFieldValue('phone4', value);
                                  } else {
                                    setCountryCodePhone4(country.dialCode);
                                    formikEmailPhone.setFieldValue('phone4', value);
                                  }
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                                error={
                                  formikEmailPhone.touched.phone4 &&
                                  Boolean(formikEmailPhone.errors.phone4)
                                }
                                helperText={
                                  formikEmailPhone.touched.phone4 && formikEmailPhone.errors.phone4
                                }
                              />
                              <Autocomplete
                                size="small"
                                variant="standard"
                                margin="dense"
                                id="phonetype4"
                                sx={{ width: 400 }}
                                options={PHONES}
                                autoHighlight
                                getOptionLabel={(option) => {
                                  console.log(option);
                                  return option.text !== undefined
                                    ? option.text
                                    : option !== undefined
                                    ? option
                                    : '';
                                }}
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                    {...props}>
                                    {option.text}
                                  </Box>
                                )}
                                renderInput={(params) => (
                                  <Box>
                                    <TextField
                                      {...params}
                                      label="Phone type"
                                      // size="small"
                                      // variant="standard"
                                      margin="dense"
                                      fullWidth
                                      name="phonetype4"
                                      inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: 16 }
                                      }}
                                      InputLabelProps={{
                                        style: { fontSize: 14 }
                                      }}
                                    />
                                  </Box>
                                )}
                                value={formikEmailPhone.values.phonetype4}
                                isOptionEqualToValue={(option, value) => option.text === value}
                                onChange={(e, value) => {
                                  console.log(value);
                                  formikEmailPhone.setFieldValue(
                                    'phonetype4',
                                    value !== null ? value.text : ''
                                  );
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                              />
                            </Stack>
                          )}
                          {!(showPhone2 && showPhone3 && showPhone4) && (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                mt: 1
                              }}
                              onClick={addPhone}>
                              <AddIcon
                                color="#003087"
                                style={{ color: '#003087', fontSize: 16, mt: 1 }}
                              />
                              <Typography
                                sx={{ color: '#003087', fontSize: 14, fontWeight: '500' }}>
                                Add phone
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
                      <MobileStepper
                        variant="dots"
                        steps={11}
                        position="static"
                        activeStep={st.activeStep}
                        sx={{
                          maxWidth: 400,
                          flexGrow: 1,
                          backgroundColor: '#FFFFFF',
                          mb: 4,
                          mt: 1
                        }}
                        nextButton={
                          <Button
                            size="large"
                            variant="contained"
                            onClick={formikEmailPhone.handleSubmit}
                            disabled={st.activeStep === 11}>
                            Next
                            {theme.direction === 'rtl' ? (
                              <KeyboardArrowLeft />
                            ) : (
                              <KeyboardArrowRight />
                            )}
                          </Button>
                        }
                        backButton={
                          <Button
                            size="large"
                            // variant="contained"
                            onClick={handleBack}
                            disabled={st.activeStep === 0}>
                            {theme.direction === 'rtl' ? (
                              <KeyboardArrowRight />
                            ) : (
                              <KeyboardArrowLeft />
                            )}
                            Back
                          </Button>
                        }
                      />
                      {loading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: green[500],
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',
                            marginLeft: '-12px'
                          }}
                        />
                      )}
                    </Box>
                  )}
                {st.activeStep === 5 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>How can we reach you?</Typography>
                      <Box sx={{ mb: 0, ml: 0, mt: 2 }}>
                        {/* <MultipleSelectChip /> */}
                        <Autocomplete
                          multiple
                          id="languages"
                          options={LANGUAGES}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.name}
                            </li>
                          )}
                          style={{ width: 400 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Language"
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: 16 }
                              }}
                              InputLabelProps={{
                                style: { fontSize: 14 }
                              }}
                            />
                          )}
                          value={formikLanguage.values.languages}
                          isOptionEqualToValue={(option, value) =>
                            value !== null ? option.name === value.name : false
                          }
                          onChange={(e, value) => {
                            console.log(value);
                            formikLanguage.setFieldValue('languages', value !== null ? value : '');
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 400
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Do you want an interpreter during medical visits?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="needInterpreter-group"></FormLabel>
                            <RadioGroup
                              aria-labelledby="needInterpreter"
                              name="needInterpreter"
                              value={formikLanguage.values.needInterpreter}
                              onChange={(e) => {
                                formikLanguage.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="Y"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="N"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikLanguage.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep === 0}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 6 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>
                        Do you have any referring MD information?
                      </Typography>
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="cardiologist"
                        label="Primary cardiologist's name"
                        name="cardiologist"
                        autoComplete="cardiologist"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        autoFocus
                        value={formikCardiologist.values.cardiologist}
                        onChange={(e) => {
                          formikCardiologist.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikCardiologist.touched.cardiologist &&
                          Boolean(formikCardiologist.errors.cardiologist)
                        }
                        helperText={
                          formikCardiologist.touched.cardiologist &&
                          formikCardiologist.errors.cardiologist
                        }
                      />
                      <MuiPhoneNumber
                        fullWidth
                        size="small"
                        defaultCountry={'us'}
                        variant="standard"
                        inputProps={{ style: { fontSize: 16 } }}
                        sx={{ mt: 2 }}
                        id="cardiologistphone"
                        value={formikCardiologist.values.cardiologistphone}
                        onChange={(value, country) => {
                          console.log(country.dialCode);
                          if (value.includes(' ') && countryCode1 !== value.split(' ')[0]) {
                            setCountryCode1(value.split(' ')[0]);
                            formikCardiologist.setFieldValue('cardiologistphone', value);
                          } else {
                            setCountryCode1(country.dialCode);
                            formikCardiologist.setFieldValue('cardiologistphone', value);
                          }
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikCardiologist.touched.cardiologistphone &&
                          Boolean(formikCardiologist.errors.cardiologistphone)
                        }
                        helperText={
                          formikCardiologist.touched.cardiologistphone &&
                          formikCardiologist.errors.cardiologistphone
                        }
                      />
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="cardiologistemail"
                        label="Cardiologist's email"
                        name="cardiologistemail"
                        autoComplete="cardiologistemail"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        value={formikCardiologist.values.cardiologistemail}
                        onChange={(e) => {
                          formikCardiologist.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikCardiologist.touched.cardiologistemail &&
                          Boolean(formikCardiologist.errors.cardiologistemail)
                        }
                        helperText={
                          formikCardiologist.touched.cardiologistemail &&
                          formikCardiologist.errors.cardiologistemail
                        }
                      />
                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 450
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Do you want to send your cardiologist your second opinion letter when it
                          is ready?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="cardiologistletter-group"></FormLabel>
                            <RadioGroup
                              aria-labelledby="cardiologistletter"
                              name="cardiologistletter"
                              value={formikCardiologist.values.cardiologistletter}
                              onChange={(e) => {
                                formikCardiologist.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatemderror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikCardiologist.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep === 0}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 7 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>
                        Do you have any referring MD information?
                      </Typography>
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="pcp"
                        label="Primary care physician's name"
                        name="pcp"
                        autoComplete="pcp"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        autoFocus
                        value={formikPCP.values.pcp}
                        onChange={(e) => {
                          formikPCP.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikPCP.touched.cardiologist && Boolean(formikPCP.errors.cardiologist)
                        }
                        helperText={formikPCP.touched.cardiologist && formikPCP.errors.cardiologist}
                      />
                      <MuiPhoneNumber
                        fullWidth
                        size="small"
                        defaultCountry={'us'}
                        variant="standard"
                        inputProps={{ style: { fontSize: 16 } }}
                        sx={{ mt: 2 }}
                        id="pcpphone"
                        value={formikPCP.values.pcpphone}
                        onChange={(value, country) => {
                          console.log(country.dialCode);
                          if (value.includes(' ') && countryCode2 !== value.split(' ')[0]) {
                            setCountryCode2(value.split(' ')[0]);
                            formikPCP.setFieldValue('pcpphone', value);
                          } else {
                            setCountryCode2(country.dialCode);
                            formikPCP.setFieldValue('pcpphone', value);
                          }
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={formikPCP.touched.pcpphone && Boolean(formikPCP.errors.pcpphone)}
                        helperText={formikPCP.touched.pcpphone && formikPCP.errors.pcpphone}
                      />
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="pcpemail"
                        label="PCP's email"
                        name="pcpemail"
                        autoComplete="pcpemail"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        value={formikPCP.values.pcpemail}
                        onChange={(e) => {
                          formikPCP.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={formikPCP.touched.pcpemail && Boolean(formikPCP.errors.pcpemail)}
                        helperText={formikPCP.touched.pcpemail && formikPCP.errors.pcpemail}
                      />
                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 450
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Do you want to send your PCP your second opinion letter when it is ready?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="pcp-group"></FormLabel>
                            <RadioGroup
                              aria-labelledby="pcpletter"
                              name="pcpletter"
                              value={formikPCP.values.pcpletter}
                              onChange={(e) => {
                                formikPCP.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatemderror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikPCP.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep === 0}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 8 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>
                        Do you have any referring MD information?
                      </Typography>
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="obgyn"
                        label="Obstetrician/maternal fetal medicine clinician's name"
                        name="obgyn"
                        autoComplete="obgyn"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        autoFocus
                        value={formikOBGYN.values.obgyn}
                        onChange={(e) => {
                          formikOBGYN.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={formikOBGYN.touched.obgyn && Boolean(formikOBGYN.errors.obgyn)}
                        helperText={formikOBGYN.touched.obgyn && formikOBGYN.errors.obgyn}
                      />
                      <MuiPhoneNumber
                        fullWidth
                        size="small"
                        defaultCountry={'us'}
                        variant="standard"
                        inputProps={{ style: { fontSize: 16 } }}
                        sx={{ mt: 2 }}
                        id="obgynphone"
                        value={formikOBGYN.values.obgynphone}
                        onChange={(value, country) => {
                          console.log(country.dialCode);
                          if (value.includes(' ') && countryCode3 !== value.split(' ')[0]) {
                            setCountryCode3(value.split(' ')[0]);
                            formikOBGYN.setFieldValue('obgynphone', value);
                          } else {
                            setCountryCode3(country.dialCode);
                            formikOBGYN.setFieldValue('obgynphone', value);
                          }
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikOBGYN.touched.obgynphone && Boolean(formikOBGYN.errors.obgynphone)
                        }
                        helperText={formikOBGYN.touched.obgynphone && formikOBGYN.errors.obgynphone}
                      />
                      <TextField
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        id="obgynemail"
                        label="Obstetrician/maternal fetal medicine clinician's email"
                        name="obgynemail"
                        autoComplete="obgynemail"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        value={formikOBGYN.values.obgynemail}
                        onChange={(e) => {
                          formikOBGYN.handleChange(e);
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={
                          formikOBGYN.touched.obgynemail && Boolean(formikOBGYN.errors.obgynemail)
                        }
                        helperText={formikOBGYN.touched.obgynemail && formikOBGYN.errors.obgynemail}
                      />
                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 450
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Do you want to send your obstetrician/maternal fetal medicine clinician
                          your second opinion letter when it is ready?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="obgynletter-group"></FormLabel>
                            <RadioGroup
                              aria-labelledby="obgynletter"
                              name="obgynletter"
                              value={formikOBGYN.values.obgynletter}
                              onChange={(e) => {
                                formikOBGYN.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatemderror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikOBGYN.handleSubmit}
                          disabled={st.activeStep === 11}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep === 0}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 9 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>
                        Do you have any additional requests?
                      </Typography>
                      <Autocomplete
                        id="program"
                        sx={{ width: 400 }}
                        options={PROGRAM}
                        autoHighlight
                        getOptionLabel={(option) => {
                          console.log(option);
                          return option.text !== undefined
                            ? option.text
                            : option !== undefined
                            ? option
                            : '';
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                            {...props}>
                            {option.text}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <Box>
                            <TextField
                              {...params}
                              label="Requested clinical program"
                              // size="small"
                              // variant="standard"
                              margin="dense"
                              fullWidth
                              name="program"
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: 16 }
                              }}
                              InputLabelProps={{
                                style: { fontSize: 14 }
                              }}
                            />
                          </Box>
                        )}
                        value={formikBCHMD.values.program}
                        isOptionEqualToValue={(option, value) => option.text === value.name}
                        onChange={(e, value) => {
                          console.log(value);
                          formikBCHMD.setFieldValue('program', value !== null ? value.text : '');
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                      />
                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 400
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Do you have a preferred surgeon at BCH?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="preferredSurgeon-group"></FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="preferredSurgeon"
                              name="preferredSurgeon"
                              value={formikBCHMD.values.preferredSurgeon}
                              onChange={(e) => {
                                formikBCHMD.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        {(formikBCHMD.values.preferredSurgeon === true ||
                          formikBCHMD.values.preferredSurgeon === 'true') && (
                          <Box>
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 16,
                                textAlign: 'left'
                              }}>
                              Preferred surgeon (optional)
                            </Typography>
                            <Autocomplete
                              id="preferredSurgeonName"
                              sx={{ width: 400 }}
                              options={SURGEON}
                              autoHighlight
                              getOptionLabel={(option) => {
                                console.log(option);
                                return option.text !== undefined
                                  ? option.text
                                  : option !== undefined
                                  ? option
                                  : '';
                              }}
                              renderOption={(props, option) => (
                                <Box
                                  component="li"
                                  sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                  {...props}>
                                  {option.text}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <Box>
                                  <TextField
                                    {...params}
                                    label="Preferred surgeon"
                                    size="small"
                                    // variant="standard"
                                    margin="dense"
                                    fullWidth
                                    name="preferredSurgeonName"
                                    inputProps={{
                                      ...params.inputProps,
                                      style: { fontSize: 16 }
                                    }}
                                    InputLabelProps={{
                                      style: { fontSize: 14 }
                                    }}
                                  />
                                </Box>
                              )}
                              value={formikBCHMD.values.preferredSurgeonName}
                              isOptionEqualToValue={(option, value) => option.text === value}
                              onChange={(e, value) => {
                                console.log(value);
                                formikBCHMD.setFieldValue(
                                  'preferredSurgeonName',
                                  value !== null ? value.text : ''
                                );
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                            />
                          </Box>
                        )}
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              textAlign: 'left'
                            }}>
                            Do you have a preferred cardiologist at BCH?
                          </Typography>
                        </Box>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="preferredCardiologist-group"></FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="preferredCardiologist"
                              name="preferredCardiologist"
                              value={formikBCHMD.values.preferredCardiologist}
                              onChange={(e) => {
                                formikBCHMD.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        {(formikBCHMD.values.preferredCardiologist === true ||
                          formikBCHMD.values.preferredCardiologist === 'true') && (
                          <Box>
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 16,
                                textAlign: 'left'
                              }}>
                              Preferred cardiologist (optional)
                            </Typography>
                            <TextField
                              size="small"
                              variant="standard"
                              margin="dense"
                              fullWidth
                              id="preferredCardiologistName"
                              name="preferredCardiologistName"
                              autoComplete="preferredCardiologistName"
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              autoFocus
                              value={formikBCHMD.values.preferredCardiologistName}
                              onChange={(e) => {
                                formikBCHMD.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={
                                formikBCHMD.touched.preferredCardiologistName &&
                                Boolean(formikBCHMD.errors.preferredCardiologistName)
                              }
                              helperText={
                                formikBCHMD.touched.preferredCardiologistName &&
                                formikBCHMD.errors.preferredCardiologistName
                              }
                            />
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatebcherror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button size="large" variant="contained" onClick={formikBCHMD.handleSubmit}>
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep === 0}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {st.activeStep === 10 && (
                  <Box component="form">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>
                        Do you have any additional requests?
                      </Typography>

                      <Box
                        sx={{
                          justifyContent: 'flex-start',
                          border: 0,
                          mt: 2,
                          width: 450
                        }}>
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 16,
                            textAlign: 'left'
                          }}>
                          Is the patient currently an inpatient or hospitalized at another hospital?
                        </Typography>
                        <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                          <FormControl>
                            <FormLabel id="inpatient-group"></FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="inpatient"
                              name="inpatient"
                              value={formikOtherInfo.values.inpatient}
                              onChange={(e) => {
                                formikOtherInfo.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}>
                              <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    No
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        {(formikOtherInfo.values.inpatient === true ||
                          formikOtherInfo.values.inpatient === 'true') && (
                          <Box>
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 16,
                                textAlign: 'left'
                              }}>
                              What is name of hospital you current admitted to?
                            </Typography>
                            <TextField
                              size="small"
                              variant="standard"
                              margin="dense"
                              fullWidth
                              id="hospitalName"
                              // label="Name of hospital current admitted to"
                              name="hospitalName"
                              autoComplete="hospitalName"
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              autoFocus
                              value={formikOtherInfo.values.hospitalName}
                              onChange={(e) => {
                                formikOtherInfo.handleChange(e);
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={
                                formikOtherInfo.touched.hospitalName &&
                                Boolean(formikOtherInfo.errors.hospitalName)
                              }
                              helperText={
                                formikOtherInfo.touched.hospitalName &&
                                formikOtherInfo.errors.hospitalName
                              }
                            />
                          </Box>
                        )}
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              textAlign: 'left'
                            }}>
                            Why did you choose Benderson Family Heart Center at BCH?
                          </Typography>
                        </Box>
                        <Autocomplete
                          id="whyChoose"
                          sx={{ width: 400 }}
                          options={WHYCHOOSE}
                          autoHighlight
                          getOptionLabel={(option) => {
                            console.log(option);
                            return option.text !== undefined
                              ? option.text
                              : option !== undefined
                              ? option
                              : '';
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                              {...props}>
                              {option.text}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <Box>
                              <TextField
                                {...params}
                                label="Reason of choose"
                                size="small"
                                // variant="standard"
                                margin="dense"
                                fullWidth
                                name="whyChoose"
                                inputProps={{
                                  ...params.inputProps,
                                  style: { fontSize: 16 }
                                }}
                                InputLabelProps={{
                                  style: { fontSize: 14 }
                                }}
                              />
                            </Box>
                          )}
                          value={formikOtherInfo.values.whyChoose}
                          isOptionEqualToValue={(option, value) => option.text === value}
                          onChange={(e, value) => {
                            console.log(value);
                            formikOtherInfo.setFieldValue(
                              'whyChoose',
                              value !== null ? value.text : ''
                            );
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                        />
                      </Box>
                    </Box>
                    <Typography style={styles.errorText}>{st.updatebcherror}</Typography>
                    <MobileStepper
                      variant="dots"
                      steps={11}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4,
                        mt: 1
                      }}
                      nextButton={
                        <Button
                          size="large"
                          variant="contained"
                          onClick={formikOtherInfo.handleSubmit}
                          // disabled={activeStep === 9}
                        >
                          Done
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}
                          disabled={st.activeStep <= 3}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
                {false && st.activeStep === 11 && (
                  <Box component="form" noValidate>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 0,
                        mt: 0,
                        width: 450
                      }}>
                      <Typography sx={styles.subTitleStyle}>Guarantor and Insurance</Typography>
                      <Box sx={{ justifyContent: 'flex-start', border: 0, mt: 2, width: 400 }}>
                        {false && (
                          <Box>
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 16,
                                textAlign: 'left'
                              }}>
                              Are you the Parent or Legal Guardian of patient?
                            </Typography>

                            <Box sx={{ ml: 2, mt: 1 }}>
                              <FormControl>
                                <FormLabel id="guarantor-group"></FormLabel>
                                <RadioGroup
                                  row
                                  aria-labelledby="guarantor"
                                  name="guarantor"
                                  //value={formik.values.guarantor}
                                  onChange={() => {
                                    //  formik.handleChange(e);
                                    dispatch(caseActions.setDataUpdated(true));
                                  }}>
                                  <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label={
                                      <Typography
                                        style={{
                                          color: '#021D4E',
                                          fontWeight: '500',
                                          fontSize: 15,
                                          textAlign: 'left'
                                        }}>
                                        Yes
                                      </Typography>
                                    }
                                  />
                                  <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label={
                                      <Typography
                                        style={{
                                          color: '#021D4E',
                                          fontWeight: '500',
                                          fontSize: 15,
                                          textAlign: 'left'
                                        }}>
                                        No
                                      </Typography>
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Box>
                          </Box>
                        )}
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-start'
                          }}>
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              textAlign: 'center'
                            }}>
                            Are you Guarantor?
                          </Typography>
                          <Tooltip
                            title="Guarantor is someone who is responsible to pay the bill."
                            placement="top-start">
                            {infoIcon}
                          </Tooltip>
                        </Box>
                        <FormControl>
                          <FormLabel id="guarantor-group"></FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="guarantor"
                            name="guarantor"
                            //value={formik.values.guarantor}
                            onChange={() => {
                              //formik.handleChange(e);
                              dispatch(caseActions.setDataUpdated(true));
                            }}>
                            <FormControlLabel
                              value="true"
                              control={<Radio />}
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  Yes
                                </Typography>
                              }
                            />
                            <FormControlLabel
                              value="false"
                              control={<Radio />}
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  No
                                </Typography>
                              }
                            />
                          </RadioGroup>
                        </FormControl>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-start'
                          }}>
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 16,
                              textAlign: 'left'
                            }}>
                            Add front and back copy of your insurance card below by drag drop to or
                            click the box (maximum file size is 4 MB).
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            ml: 0,
                            mt: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}>
                          <DropzoneArea
                            acceptedFiles={['image/*']}
                            dropzoneText={
                              <Typography
                                style={{
                                  color: '#021D4E',
                                  fontWeight: '800',
                                  fontSize: 12,
                                  textAlign: 'center'
                                }}>
                                Add font
                              </Typography>
                            }
                            onChange={(files) => console.log('Files:', files)}
                            filesLimit={1}
                            showFileNames={false}
                            showPreviews={false}
                            showPreviewsInDropzone={true}
                            maxFileSize={4000000}
                          />

                          <DropzoneArea
                            acceptedFiles={['image/*']}
                            dropzoneText={
                              <Typography
                                style={{
                                  color: '#021D4E',
                                  fontWeight: '800',
                                  fontSize: 12,
                                  textAlign: 'center'
                                }}>
                                Add back
                              </Typography>
                            }
                            onChange={(files) => console.log('Files:', files)}
                            filesLimit={1}
                            showFileNames={false}
                            showPreviews={false}
                            showPreviewsInDropzone={true}
                            maxFileSize={4000000}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <MobileStepper
                      variant="dots"
                      steps={13}
                      position="static"
                      activeStep={st.activeStep}
                      sx={{
                        maxWidth: 400,
                        flexGrow: 1,
                        backgroundColor: '#FFFFFF',
                        mb: 4
                      }}
                      nextButton={
                        <Button size="large" variant="contained" onClick={handleDone}>
                          Done
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="large"
                          // variant="contained"
                          onClick={handleBack}>
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
        )}
        {st.showWelcome === true && (
          <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
            <Box sx={styles.formCardContainerStyle}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, width: 450 }}>
                <Button size="large" onClick={handleHome}>
                  <KeyboardArrowLeft />
                  Home
                </Button>
              </Box>
              <Stack direction="row" sx={styles.formCardTitleStyle}>
                <HeartLogo fontSize={50} />
                <Typography sx={{ my: 1, fontSize: 20, fontWeight: '700' }}>Welcome!</Typography>
              </Stack>
              <Box sx={styles.containerStyle}>
                <Box component="form" noValidate>
                  <Box sx={{ justifyContent: 'flex-start', border: 0, mt: 2, width: 400 }}>
                    <Typography style={{ fontSize: 16, color: '#021D4E', textAlign: 'left' }}>
                      An account is created for you successfully. You can now continue to request
                      your second opinion request or request to view case that has been created for
                      you by second opinion coordinator.
                    </Typography>
                    <Box sx={{ mb: 2, ml: 2, mt: 1 }}>
                      <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                        <RadioGroup
                          aria-labelledby="selection"
                          name="selection"
                          value={selection}
                          onChange={handleSelectionChange}>
                          <Box key={0}>
                            <FormControlLabel
                              value={0}
                              control={<Radio />}
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  Request to create a case
                                </Typography>
                              }
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              value={1}
                              control={<Radio />}
                              label={
                                <Typography
                                  style={{
                                    color: '#021D4E',
                                    fontWeight: '500',
                                    fontSize: 15,
                                    textAlign: 'left'
                                  }}>
                                  Request to view a case
                                </Typography>
                              }
                            />
                          </Box>
                        </RadioGroup>
                      </FormControl>
                    </Box>
                    <Box sx={{ mt: 2, mb: 8, position: 'relative' }}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={styles.formCardButtonStyle}
                        onClick={handleSelectionContinue}>
                        Continue
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
        {st.activeStep === 0 && showContactMessage === true && <ContactMessage />}
        {(st.activeStep === 1 || st.activeStep === 3) && showCaseAlreadyLinked === true && (
          <CaseExistMessage />
        )}
        {(st.activeStep === 1 || st.activeStep === 3) && showCaseAccessRequested === true && (
          <RequestAccessMessage />
        )}
        {/* </PerfectScrollbar> */}
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}

const styles = {
  gridContainerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 600,
    background: '#FFFF'
  },
  subTitleStyle: {
    display: 'flex',
    justifyContent: 'center',
    my: 1,
    fontSize: 18,
    fontWeight: '500'
  },
  containerStyle: {
    my: 0,
    mx: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    width: 400
  },
  errorText: {
    color: '#d32f2f',
    fontWeight: 'normal',
    fontSize: 16,
    marginBottom: 10,
    marginTop: 0,
    textAlign: 'left',
    marginLeft: 0
  },
  linkItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: 0,
    mt: 2,
    mb: 4
  },
  linkTextStyle: {
    color: '#003087'
  },
  inputRoot: {
    fontSize: 20
  },
  labelRoot: {
    fontSize: 20,
    color: 'red',
    '&$labelFocused': {
      color: 'purple'
    }
  },
  labelFocused: {}
};
